<script>
// Add branch for median average mood.
import {onMount } from 'svelte';
import router from 'page'
import { fade, fly,scale, draw } from 'svelte/transition';  
import { cubicOut } from 'svelte/easing';
import { quintOut } from 'svelte/easing';
import {supabase} from "./supabaseClient"
import { MaterialApp, Snackbar,Avatar, Button,List, ListItem,Subheader, Menu, TextField, Dialog, Card, CardTitle,CardText,CardActions, Chip, Switch, Tooltip,NavigationDrawer,Divider
} from 'svelte-materialify';

import { Settings,Settings2, SquareX, X } from 'lucide-svelte';
//import { EmojiButton } from '@joeattardi/emoji-button';
//import { createPicker } from 'picmo';
import { createPopup } from '@picmo/popup-picker';
import { autoTheme, lightTheme, darkTheme } from 'picmo';

import { SSE } from 'sse.js'
import moment from 'moment';  //Remove?
import emojiRegex from 'emoji-regex';
import DeviceDetector from "svelte-device-detector";
import { flip } from 'svelte/animate';
import { marked } from 'marked';
import Icon from 'svelte-awesome';
import { remove, close } from 'svelte-awesome/icons';
import { faTimesCircle, faSquare, faSave } from '@fortawesome/free-regular-svg-icons';
import { faShare, faBorderAll,faEye, faEyeSlash, faChevronRight, faChevronLeft, faTable, faUserPlus, faSpinner, faCamera, faLightbulb,faCalendarMinus, faUserMinus,faPlus, faBrain, faPen} from '@fortawesome/free-solid-svg-icons';
  import { ArrowUp, ArrowDown } from 'lucide-svelte';

import Speedometer from "svelte-speedometer"
import Sentiment from "sentiment"
import Editable from "./Editable.svelte"

import {user} from "./sessionStore"
import QRCode from "./QRJS.svelte"
import MoodSentimentCart from "./moodSentimentChart.svelte"
// import MoodBoardGrid from "./MoodBoardGrid.svelte"
// import MoodBoard from "./MoodBoard.svelte"
import allEmoji from "./coreEmoji.js"
import allGifs from "./coreGifs.js"
import sentimentColourScale from "./sentimentColourScale"
import {getReasonFont} from "./sentimentFontScale"
import UserMenu from "./UserMenu.svelte"
import MoodStory from "./moodStory.svelte"
import ReminderForm from "./ReminderForm.svelte"
import Reminder from "./Reminder.svelte"
import UpgradeDialog from './UpgradeDialog.svelte';
    import { debug } from 'svelte/internal';

let thisBoard = {}
let attendees = []
let boardInstances = []
let displayInstances = boardInstances;
let moods = []
let reminders =[];
let reminder;
let moodReason = ''
let helpRequired = ''
let showHelpField = false
let showAddAttendeeForm = false;
// let currentInstance = {};
let currentInstance;
let boardHasOwner = true;
let sentiment = new Sentiment();

let  windowsOS = navigator.appVersion.indexOf('Win') != -1;
let betaFeaturesEnabled = localStorage.getItem('MoodFirstBeta') == 'true' ? true : false;
let previouslyAddedEmoji = [];


$: coreEmoji = allEmoji.filter(e => {
  return (!e.Premium || (user && user.plan));
});

$: coreGifs = allGifs.filter(e => {
  return (!e.Premium || (user && user.plan));
});

$: premiumGifs = allGifs
  .filter(e => e.Premium)
  .sort(() => Math.random() - 0.5);

$: {
  // Flatten and filter out JSON strings (like GIF mood objects)
  let uniqueEmoArr = [
    ...new Set(
      [].concat(...moods.map(m => m.mood)).filter(e => {
        // Keep emoji-like strings only
        if (typeof e !== 'string') return false;

        // Exclude stringified JSON objects (Giphy moods)
        try {
          const parsed = JSON.parse(e);
          return false; // exclude anything that's valid JSON
        } catch {
          return true; // keep plain emoji or non-JSON strings
        }
      })
    )
  ];

  // Add filtered emoji to previouslyAddedEmoji
  uniqueEmoArr.forEach(u => {
    if (!coreEmoji.some(c => c.Emoji === u) && !previouslyAddedEmoji.includes(u)) {
      previouslyAddedEmoji = [...previouslyAddedEmoji, u];
    }
  });
} 



let NewAttendeeName = ''

// Save & signup Properties
let email;
let password;
let showPassword = false;
let signUpErrorMessage =''

let userInitials = $user ? $user.email.substring(0,1).toUpperCase() : 'x'
let displayAddAttendeeErrror = '';

const envName = 'SVELTE_APP_ENV_NAME'
const sbURL = 'SVELTE_APP_SUPABASE_URL'

$: currentInstanceSentiment = currentInstance ? Number.parseFloat(currentInstance.avg_sentiment_score).toFixed(1).toString() : '';

// $: currentInstanceSentiment = boardInstances[0] ? Number.parseFloat(boardInstances[0].avg_sentiment_score).toFixed(1).toString() : '';
// $: currentInstanceSentimentColour = sentimentColourScale.filter(a => a.sentiment == '0.3')[0].colourCode
$: currentInstanceSentimentColour = getSentimentColourCode(currentInstanceSentiment)


let selectedAttendee
let selectedInstance
let selectedEmoji=[]
let selectedStickers = [];
$:combinedEmojiStickers = [...selectedEmoji,...selectedStickers]

// let emojiCategories = Array.from(new Set(coreEmoji.map(e => e.Category)))
$: emojiCategories = Array.from(new Set((coreEmoji || []).map(e => e.Category)));


 function calculateMedian(arr) {
    const mid = Math.floor(arr.length / 2),
          nums = [...arr].sort((a, b) => a - b);
    return arr.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
  }

  // Reactive statement to calculate selectedEmojiSentiment
  let currentSentiment = 0;
  let gifSentiment = null;

   let totalSentiment = 0;
    let count = 0;
  $:{
    /*
      Logic:
      Scenario 1: Giphy selected (can only be selected by themselves)
      Scenario 2: Stickers and or core emoji selected
        Scenario 2.1: Stickers selected
        Scenario 2.2: Emoji selected
    */
    
    // Reset currentSentiment and gifSentiment
    currentSentiment = 0;
    gifSentiment = null;
    totalSentiment = 0;
    count = 0
   
    if(selectedGiphy){
  
      /* Scenario 1: Gify selected  
       Calculate sentiment from gif title and search text
       Set gifSentiment and add to total Sentiment
      */
          let gifTitleSentiment = linearScale(sentiment.analyze(selectedGiphy.title).comparative);
          let gifSearchSentiment = linearScale(sentiment.analyze(giphySearchTerm).comparative);
          gifSentiment = (gifTitleSentiment + gifSearchSentiment) / 2
          currentSentiment = gifSentiment;
    } else {
      /* Scenario 2: Stickers and or core emoji selected */

      if (selectedStickers && selectedStickers.length > 0 ){
        /* Scenario 2.1 Stickers selected */
        const sentimentScores = selectedStickers.map(obj => obj.SentimentScore);
        totalSentiment += calculateMedian(sentimentScores);
        gifSentiment = totalSentiment;
        count ++;
      }

      if (selectedEmoji && selectedEmoji.length > 0) {
        /* Scenario 2.2 Emoji selected */
        let emojiScores = selectedEmoji.map(emoji => {
        let found = coreEmoji.find(e => e.Emoji === emoji);
        return found ? found.SentimentScore : null;
        }).filter(score => score !== null); // Filter out null scores
        if (emojiScores.length > 0){
          totalSentiment  += emojiScores.length > 0 ? calculateMedian(emojiScores) : 0;
          count++; 
        }

      }

      currentSentiment = count > 0 ? totalSentiment / count : 0;
    }

  }

// let boardMode='GRID'  // Options are GRID or BOARD
let boardMode = false;
var gridContentWidth;
// user.set(supabase.auth.user())

var urlParams =   new URLSearchParams(window.location.search)
let boardAccessKey = urlParams.get('accessKey')
let debugMode = urlParams.get('debug') === 'true';
let displayBoardQuestion = false

var gridElement;
var gridContentWidth;
$: gridScrollable = gridElement ? gridContentWidth > gridElement.clientWidth : false;

// let currentSentiment = 0;

onMount(async () => {
  displayBoardQuestion=true;

   urlParams = new URLSearchParams(window.location.search)

  let { data, error } = await supabase
    .rpc('get_board', {
      _access_key:urlParams.get('accessKey')
    })
    if (error) console.error(error)
    //else console.log(data)
    thisBoard = data
   // Check if the board was not retrieved and redirect
    if (!thisBoard || !thisBoard.id) { 
      window.location.href = '/boardNotFound';  // Redirect to a "not found" page or any other page
      return;  // Exit the function early
    }
   
    get_board_instances()
    getAttendees()
    // getMoods() 
    checkHasOwner()
    getReminders();
    document.title= thisBoard.title + " | MoodFirst"

    // Reduce Emoji size for Windows
    if (navigator.appVersion.indexOf("Win")!=-1) {
      var style = document.createElement('style');
      style.type = 'text/css';
      style.innerHTML = '.multipleSelectedEmoji {font-size: 36px !important}';
      document.getElementsByTagName('head')[0].appendChild(style);
    }

    // Set mode if paramteer is provided
   if(urlParams.get('boardMode') != null  && urlParams.get('boardMode') == 'true' ) {
     handleChangeBoardMode(true);
   }   

   // Show ideas if parameter provided
   if(urlParams.get('showIdeas') != null  && urlParams.get('showIdeas') == 'true' ) {
     showIdeaBar = true;
   }


   //set Custom Data for Lucky Orange Tracking
   var customData = {
    'Board' : thisBoard.title,
    'Board ID' : thisBoard.id
    }
    window._loq = window._loq || []    
    window._loq.push(['custom', customData])

})


const checkHasOwner = async () => {
  let { data, error } = await supabase
  .rpc('has_owner', {
    _access_key: urlParams.get('accessKey')
  })

if (error) console.error(error)
  else {
    boardHasOwner = data
  }
}

// Paging state for board instances
  let page           = 0;
  const pageSize     = 40;
  let isLoading      = false;
  let hasNextPage    = false;
  $: hasPreviousPage = page > 0;

  async function pageDown() {
    // always grab the current page value
    const next = page + 1;
    await get_board_instances(next);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

// Load a page of instances (with peek) + their moods
  async function get_board_instances(p = 0) {
    isLoading = true;
    try {
      // fetch page p, asking for one extra to detect “next”
      const { data: insts = [], error: err1 } = await supabase.rpc('get_board_instances_paged', {
        _board_id: thisBoard.id,
        _limit:    pageSize + 1,
        _offset:   p * pageSize
      })
      
      if (err1) throw err1;

      hasNextPage    = insts.length > pageSize;
      boardInstances = insts.slice(0, pageSize);
      page           = p;

      const today = moment(new Date()).format('YYYY-MM-DD');
      var placeHolderInstance;
      
      // now load moods for exactly these instances
      const ids = boardInstances.map(i => i.id);
      const { data: mds = [], error: err2 } = await supabase
        .rpc('get_board_moods_for_instances', {
            _board_id:     thisBoard.id,
            _instance_ids: ids
        });
      if (err2) throw err2;

      moods = mds;

      // Check if today's date is already there and add placeholder if not
      if (page === 0) {
        if (!boardInstances.find(record => record.date === today)){
          let placeHolderInstance = {
            id:'placeholder-today',
            date: today
          }
          var updatedInstances = [...boardInstances,placeHolderInstance]
          updatedInstances.sort((a, b) => new Date(b.date) - new Date(a.date));
          boardInstances = updatedInstances
          }
        }

        if (boardMode) {
        if(currentInstance) {
          currentInstance = boardInstances.find(e => e.date == currentInstance.date);
          let index = boardInstances.indexOf(currentInstance);
          displayInstances = boardInstances.slice(index, index+1)
        } else {
          currentInstance = boardInstances[0]
          displayInstances = boardInstances.slice(0,1);
        }
      } else {
        displayInstances = boardInstances;
        currentInstance = boardInstances[0]; // Fix bug where board colour not updating in grid mode.
      }
    


    } catch (e) {
      console.error('loadInstances error', e);
    } finally {
      isLoading = false;
    }
  }


const get_board_instances_OLD = async () => {
  let { data, error } = await supabase
  .rpc('get_board_instances', {
    boardid:thisBoard.id
  })

if (error) console.error(error)
else {

  /* Add a place holder for today's date (client-side) */
  boardInstances = data;
  const today = moment(new Date()).format('YYYY-MM-DD');
  var placeHolderInstance;

  // Check if today's date is already there
  if (!boardInstances.find(record => record.date === today)){
    let placeHolderInstance = {
      id:'placeholder-today',
      date: today
    }
    var updatedInstances = [...boardInstances,placeHolderInstance]
    updatedInstances.sort((a, b) => new Date(b.date) - new Date(a.date));
    boardInstances = updatedInstances
    }
  }

  if (boardMode) {
    if(currentInstance) {
      currentInstance = boardInstances.find(e => e.date == currentInstance.date);
      let index = boardInstances.indexOf(currentInstance);
      displayInstances = boardInstances.slice(index, index+1)
    } else {
      currentInstance = boardInstances[0]
      displayInstances = boardInstances.slice(0,1);
    }
  } else {
    displayInstances = boardInstances;
    currentInstance = boardInstances[0]; // Fix bug where board colour not updating in grid mode.
  }
}


const getAttendees = async () => {
  let { data, error } = await supabase
  .rpc('get_board_attendees', {
    boardid:thisBoard.id
  })
if (error) console.error(error)
// else attendees =  shuffleArray(data);
else {
 
   if (urlParams.get('sortAlpha') == 'true' ){
      data.sort((a, b) => a.name.localeCompare(b.name));;
   }
  attendees = data;
  if(attendees.length == 0) {
    document.getElementById('NewAttendeeNameField').focus();
  }
  }
  // createChart()
}

const getReminders = async ()  => {
  const { data, error } = await supabase
    .from('reminders')
    .select('*')
    .eq('board_id', thisBoard.id);

  if (error) {
    console.error('Error loading reminders:', error.message);
    return;
  }
  reminders = data;
  reminder = data[0];
}


function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}


const getMoods = async () => {

let { data: moodData, error } = await supabase
  .rpc('get_board_moods', {
    boardid: thisBoard.id
  })
if (error) console.error(error)
else {
  moods=moodData
}
}
 

function getSentimentColourCode (sentiment) {
    if (Number.parseFloat(sentiment)) {
      var sentimentFixed = Number.parseFloat(sentiment).toFixed(1)
      return sentimentColourScale.filter(a => a.sentiment == sentimentFixed)[0].colour_code
    } else {
      //return 'green'
      return sentimentColourScale.filter(a => a.sentiment == 0)[0].colour_code;
  }
}


let displayBoardChangesOwnerMessage=false;
let boardChangeOperation ='';

const handleSaveBoardTitle = async (newTitle) => {
  const { error} = await supabase
    .from('boards')
    .update({ title: newTitle })
    .eq('id', thisBoard.id)
    if (error) console.error(error);
}

const handleUpdateBoardNotOwner = (operation) => {
  boardChangeOperation = operation;
  displayBoardChangesOwnerMessage = true;
}

// Move “previous” (to older dates):
  async function handleClickPreviousDate() {
  const idx = boardInstances.indexOf(currentInstance);

  // 1) Move within current page
  if (idx + 1 < boardInstances.length) {
    currentInstance  = boardInstances[idx + 1];
    displayInstances = [currentInstance];
    return;
  }

  // 2) Page forward if possible
  if (hasNextPage) {
    await get_board_instances(page + 1);
    currentInstance  = boardInstances[0];
    displayInstances = [currentInstance];
    return;
  }

  // 3) Otherwise, do nothing (and exit)
  return;
}

async function handleClickNextDate() {
  const idx = boardInstances.indexOf(currentInstance);

  // 1) Move within current page
  if (idx > 0) {
    currentInstance  = boardInstances[idx - 1];
    displayInstances = [currentInstance];
    return;
  }

  // 2) Page backward if possible
  if (hasPreviousPage) {
    await get_board_instances(page - 1);
    currentInstance  = boardInstances[boardInstances.length - 1];
    displayInstances = [currentInstance];
    return;
  }

  // 3) Otherwise, do nothing
  return;
}



const handleChangeBoardMode = async (newBoardMode) => {
    if (newBoardMode) {
      currentInstance =  boardInstances.slice(0,1)[0];
      boardMode = true;
      displayInstances = boardInstances.slice(0,1);
      setUrlParameter('boardMode','true')
    } else {
      displayInstances = boardInstances;
      boardMode = false;
      setUrlParameter('boardMode','false')
    }
}


function setUrlParameter(paramName, paramValue) {
    const url = new URL(window.location.href);
    url.searchParams.set(paramName, paramValue);
    window.history.replaceState({}, '', url);
}

/* Add Attendee */
let showAddAttendeeFormError = false
const handleAddAttendee = async () => {
  if (NewAttendeeName == '') {
    showAddAttendeeFormError = true;
    displayAddAttendeeErrror= "Attendees need to have a name 😀"
    return
  }
  if(attendees.filter(e => e.name == NewAttendeeName).length > 0){
    showAddAttendeeFormError = true;
    displayAddAttendeeErrror= NewAttendeeName + " is already here 😀"
    return
  }

   showAddAttendeeForm = false; // Required for board mode
  const { data, error } = await supabase
  .from('attendees')
  .insert([
    { board_id: thisBoard.id, name: NewAttendeeName},
  ],
  {
    returning:'minimum'
  }
  )
  if (error) {
 alert(error.message)
 return // abort
 }
 else {
  getAttendees()
  console.log('boardChannel send event: attendeeUpdate')
  boardChannel.send({type: 'broadcast', event: 'attendeeUpdate', payload: { }})
 }
  NewAttendeeName=''
}

  function updateMoodsArray(moodElement) {
    const idToUpdate = moodElement._attendee_id;
    const boardInstanceIdToUpdate = moodElement._instance_id;

    // Need to check for placeholder records using the date instead.
    var elementToUpdate = moods.find((el) => el.attendee_id ===  idToUpdate && (el.board_instance_id === boardInstanceIdToUpdate || el._instance_date === moodElement._instance_date));
    
    //Create the array elemen if it doesn't exist.
    if (elementToUpdate == null) {
      elementToUpdate = {attendee_id:idToUpdate, board_instance_id:boardInstanceIdToUpdate }
    }
    elementToUpdate.mood = moodElement._mood
    elementToUpdate.mood_stickers = moodElement._mood_stickers;
    elementToUpdate.reason = moodElement._reason
    elementToUpdate.help_required = moodElement._help_required
    elementToUpdate._instance_date = moodElement._instance_date;
    elementToUpdate.giphy_url = moodElement._giphy_url;
    elementToUpdate.sentiment = moodElement._sentiment;
    elementToUpdate.overall_sentiment = moodElement.overall_sentiment;
    moods= [...moods,elementToUpdate]
  }
  
  var Events;
  var boardChannel = supabase.channel(boardAccessKey)

  // if(betaFeaturesEnabled) {

     // boardChannel = supabase.channel(boardAccessKey)

     // Listen for broadcast events
    boardChannel.on('broadcast', { event: '*' }, (payload) => {
        console.log('boardChannel Event received')
        if (payload.event == 'moodUpdate') {
          console.log('boardChannel event: moodUpdate')

          get_board_instances ()
          updateMoodsArray (payload.payload.moodData)
          beep()
        } else if (payload.event == 'attendeeUpdate') {
          console.log('boardChannel event: attendeeUpdate')
          getAttendees()
        } else if (payload.event == 'instanceUpdate') {
          console.log('boardChannel event: instanceUpdate')
          get_board_instances()
        }
      })
      .subscribe()

  // } else {

  //      // Listen for broadcast events - subscribe to the channel but don't do anything
  //   boardChannel.on('broadcast', { event: '*' }, (payload) => {
  //       console.log('boardChannel Event received')
  //     })
  //     .subscribe()

  //   Events = supabase
  // .channel('events')
  // .on('postgres_changes', { event: '*', schema: 'public', table: 'events' }, (payload) =>
  //   {
  //      // console.log('Change received!', payload)
  //     getAttendees()
  //     getMoods()
  //     get_board_instances ()
  //     beep()
  //   }
  // )
  // .subscribe()
  // }


const handleSignUp = async () => {

  // Create Account
  let { user, error } = await supabase.auth.signUp({
    email: email,
    password: password
  })

  if (error) {
    signUpErrorMessage = error.message
    console.log(error)
    password=''
    return;
  } else {
    // Update Board Owner to current user
    let { data, updateOwnerError } = await supabase
    .rpc('set_board_owner_current_user', {
      _board_id: thisBoard.id
    })
    if (updateOwnerError) {
      console.error(error)
    } else {
       boardHasOwner = true
    }
    active = false
  }

 
}

const handleSignOut = async () => {
  let { error } = await supabase.auth.signOut()
  router.redirect('/')
}

const handleLogin = async () => {
  // handleLogin
  let { user, error } = await supabase.auth.signIn({
    email: email,
    password: password
  })
  if (error) alert(error)

  // Update Board Owner to current user
  let { data, updateError } = await supabase
  .rpc('set_board_owner_current_user', {
    _board_id: thisBoard.id
  })
  if (updateError) console.error(updateError)
  else console.log(data)

  boardHasOwner = true
  active = false
}

const navMyBoards = async () => {
  window.location.href='/myboards'
}

let active2 = false;

const handleClickMood = async (event) => {
  // selectedAttendee = event.detail.attendeeCell;
  // selectedInstance = event.detail.instance;
  selectedAttendee = event.attendeeCell;
  selectedInstance = event.instance;
  let selectedMood = moods.filter(x => x.board_instance_id == selectedInstance.id && x.attendee_id == selectedAttendee.id)[0]
  if(selectedMood && selectedMood.mood) {
    selectedEmoji = selectedMood.mood;
    selectedStickers = selectedMood.mood_stickers;
  }
  if(selectedMood && selectedMood.reason) moodReason = selectedMood.reason
  if (selectedMood && selectedMood.help_required) helpRequired = selectedMood.help_required
  if (selectedMood && selectedMood.giphy_url && selectedMood.giphy_url != '') selectedGiphy = selectedMood.giphy_url;
  active2=true;
}
//
// const handleClickMood = async (instance, attendee) => {
//   // alert(attendee.name +'\n' + instance.date)
//   selectedAttendee = attendee; 
//   selectedInstance = instance;
//   active2=true;
// }

const handleClickEmoji = async (emoji) => {
  selectedGiphy = null;
  //currentSentiment = null;
  // let emoji = event.target.innerText;
  selectedEmoji = [...selectedEmoji,emoji]
  var reasonArea = document.getElementById('whysThat')

  if (reasonArea) {
    reasonArea.focus()
  }
}

const handleClickSelectedEmoji = async () => {
  var index = selectedEmoji.indexOf(event.target.innerText)
  if (index !== -1) {
    selectedEmoji.splice(index,1)
    selectedEmoji = selectedEmoji // trigger reactivity
  }
  }

 const handleClickSelectedSticker = async (sticker) => {
  let indexToRemove = selectedStickers.findIndex(item => item.GifURL === sticker);
  if (indexToRemove !== -1) {
    selectedStickers.splice(indexToRemove, 1);
  }
  selectedStickers = selectedStickers; // Trigger reactivity. 
 }


const handleClickNeedHelp = async () => {
  showHelpField= true;
  window.setTimeout(() => document.getElementById('helpRequiredField').focus(), 0);
}

const handleConfirmMood = async () => {
  let gifURLStr = '';
  if (selectedGiphy) {
    gifURLStr = selectedGiphy.images ? selectedGiphy.images.original.webp : selectedGiphy.GifURL + '?ep=v1_stickers_search';
  }

  let moodData =  {
    // _instance_id: selectedInstance.id == '' ? null : selectedInstance.id,
    _instance_id: selectedInstance.id ,
    _mood: selectedEmoji,
    _mood_stickers: selectedStickers,
    _attendee_id: selectedAttendee.id,
    _board_id: thisBoard.id,
    _reason: moodReason,
    _help_required: helpRequired,
    _instance_date: selectedInstance.date,
    // _giphy_url: selectedGiphy.GifURL,
    _giphy_url: gifURLStr,
    _sentiment: gifSentiment, // Only send Gif sentiment to db. Emoji sentiment calcualted on server
    // overall_sentiment: selectedEmojiSentiment  // not sent to database
    overall_sentiment: currentSentiment // not sent to database
  }

  // Update board with new mood
  updateMoodsArray(moodData);

  // Broadcast new mood to other users on the board.
  // There is a bug here if the instance is a place holder as the mood is sent with _instance_id set to null! 
  console.log('boardChannel send event: moodUpdate')
  boardChannel.send({type: 'broadcast', event: 'moodUpdate', payload: { moodData},})
  // Save or update Mood record in the database.
  if(moodData._instance_id === 'placeholder-today') {
    moodData._instance_id = null;    // Remove the placeholder id.
  }
 delete moodData.overall_sentiment ; // Remove - will be set by database trigger
  let { data, error } = await supabase
  .rpc('set_mood',moodData)
  if (error) { 
    console.error(error)
  } 

  // Check mood type
  let moodType = "unknown";
  if (moodData._giphy_url && moodData._giphy_url.trim() !== "") {
      moodType = "gif"; // Exclusive type
    } else {
      const types = [];
      if (moodData._mood && moodData._mood.length > 0) {
        types.push("emoji");
      }
      if (moodData._mood_stickers && moodData._mood_stickers.length > 0) {
        types.push("sticker");
      }

      // Join types if both present
      if (types.length > 0) {
        moodType = types.join("+"); // e.g. "emoji+sticker"
      }
    }
  // Log event to Google Analytics
   if (typeof gtag !== 'undefined') {
        gtag('event', 'mood_submit', {
          mood_type: moodType,
          mood_source: 'web'
        });
    }

  // Update Board instances to refresh the sentiment
  // get_board_instances ()
  await get_board_instances(page);
  // getMoods()
  beep()

  // Close Dialog & reset fields
  active2=false;
  selectedEmoji = [];
  selectedStickers = [];
  selectedGiphy = ''
  moodReason =''
  helpRequired = ''
  showHelpField = false;
  //currentSentiment = null;
  giphySearchresults = [];
}

const handleCancelSelectMood = async () => {
  selectedEmoji = []
  selectedStickers = [];
  moodReason =''
  active2=false;
  showHelpField = false;
  helpRequired = ''
  selectedGiphy = ''
}

let active = false;
let signUpAlreadyRegistered = false;
function open() {
  active = true;
}

const alreadyRegisered = async () => {
  signUpAlreadyRegistered = true;
}

function closeDialog() {
  active = false;
}

function beep() {
  var snd = new Audio('/audio/010706469-blip-5.wav');
  snd.volume = 0.2
  snd.play();
}

function emojiInCategories(category) {
  return coreEmoji.filter(e => e.Category == category).sort((a,b) => b.SentimentScore - a.SentimentScore )
}

function gifsInCategories(category) {
  return coreGifs.filter(e => e.Category == category);
}


let confirmmDeleteActive = false;
let deleteAttendeeID;
let deleteAttendeeName;
function showConfirmDeleteAttendee (attendee) {
  deleteAttendeeID = attendee.attendeeID;
  deleteAttendeeName = attendee.name;
  confirmmDeleteActive = true

}


function closeConfirmAttendeeDelete () {
  confirmmDeleteActive = false;
}

let confirmDeleteDateActive = false
let deleteInstanceID;
function confirmDeleteDate (instance) {
   
  confirmDeleteDateActive = true;
  deleteInstanceID = instance.instanceID
}


function closeConfirmDeleteDate () {
  confirmDeleteDateActive = false;
}

const handleDeleteDate = async () => {
  const { data, error } = await supabase
  .from('board_instances')
  .delete()
  .eq('id',deleteInstanceID)
  if (error) {
    console.log(error)
  }
  else {
    get_board_instances()
    console.log('boardChannel send event: instanceUpdate')
    boardChannel.send({type: 'broadcast', event: 'instanceUpdate', payload: { }})
    deleteInstanceID='';
    confirmDeleteDateActive = false;
  }
}

const handleDeleteAttendee = async () => {
  const { data, error } = await supabase
  .from('attendees')
  .delete()
  .eq('id',deleteAttendeeID)
  if (error) {
    console.log(error)
  }
  else {
    deleteAttendeeID='';
    confirmmDeleteActive = false;
    getAttendees()
    console.log('boardChannel send event: attendeeUpdate')
    boardChannel.send({type: 'broadcast', event: 'attendeeUpdate', payload: { }})
  }

  }

// Instatntiate Emoji Picker - New Version
var triggerButton = document.querySelector('#emoji-trigger');
const picker = createPopup(
  {XshowPreview: false,
  //theme: lightTheme,
  className: 'picker',
  categories: ['activities','animals-nature','custom', 'food-drink', 'objects', 'people-body', 'recents', 'smileys-emotion', 'symbols','travel-places']
  }
, {
  referenceElement: triggerButton,
  triggerElement: triggerButton,
  className: 'popUpPicker',
  hideOnEmojiSelect: false,
  showCloseButton: false
});


// Set Emoji Picker select event - New Version
picker.addEventListener('emoji:select', event => {
  //console.log('Emoji selected:', event.emoji);
  selectedEmoji = [...selectedEmoji,event.emoji]
});


function showEmojiPicker() {
   // Old Version
   // const trigger = document.querySelector('#emoji-trigger');
   // picker.togglePicker(trigger);
  
  //New Version 
  picker.referenceElement = document.querySelector('#emoji-trigger');
  picker.triggerElement = document.querySelector('#emoji-trigger');
  picker.toggle();
}

let showGiphyDialog=false;
let giphySearchTerm = ''
let giphyLlimit=100;
let giphySearchresults =[];
let stickerSearchresults =[];
let selectedGiphy = null;
let selectedGifScore = null;

let giphyLoading = false;
const giphyApiKey = 'RBLg0DGTBHI7rjt7JKDlcVkDCD2uRDwV';
var giphySearchPage = 0;
$:giphySearchOffset = giphySearchPage * 100;
$:giphySearchResultsHeight = (600 * giphySearchPage) + 'px';

const handleSearchGiphy = async () => {
  giphyLoading = true;
  giphySearchresults =[];
  giphySearchPage = 1;
  loadGiphy()
}

const handlePageGiphy = async () => {
  giphyLoading = true;
  console.log('handlePageGiphy: offset=' + giphySearchOffset)
  ++giphySearchPage;
  loadGiphy();
}

const loadGiphy = async () => {
    var url = `https://api.giphy.com/v1/gifs/search?api_key=${giphyApiKey}&q=${giphySearchTerm}&limit=${giphyLlimit}&offset=${giphySearchOffset}`;
    console.log(url)
    // setTimeout(() => {
      fetch(url)
        .then(response => response.json())
        .then(data => {
          giphySearchresults = [...giphySearchresults,...data.data];
          giphySearchresults = giphySearchresults;
          giphyLoading = false;
          console.log(giphySearchresults)
        });
    // }
    // , 3000);

}

const loadStickers = async () => {
    // var url = `https://api.giphy.com/v1/stickers/search?api_key=${giphyApiKey}&q=${giphySearchTerm}&limit=${giphyLlimit}&offset=${giphySearchOffset}`;  
     var url = `https://api.giphy.com/v1/stickers/search?api_key=${giphyApiKey}&q=${giphySearchTerm}&limit=${giphyLlimit}&offset=${giphySearchOffset}`;
    console.log(url)
    // setTimeout(() => {
      fetch(url)
        .then(response => response.json())
        .then(data => {
          stickerSearchresults = [...stickerSearchresults,...data.data];
          stickerSearchresults = stickerSearchresults;
          // giphyLoading = false;
          console.log(giphySearchresults)
        });
    // }
    // , 3000);

}

const handleSelectSticker = async (sticker) => {
  selectedStickers = [...selectedStickers,sticker];
  var reasonArea = document.getElementById('whysThat')
  if (reasonArea) {
    reasonArea.focus()
  }
}

const handleSelectGiphy = async (giphy) => {
  selectedEmoji = [];
  selectedStickers = [];
  // selectedGiphy = giphy.images.original.url
  // selectedGiphy = (giphy.images) ? giphy.images.original.webp : giphy.GifURL;
  selectedGiphy = giphy;
 

  var reasonArea = document.getElementById('whysThat')
  if (reasonArea) {
    reasonArea.focus()
  }
  showGiphyDialog = false;
  // var titleSentiment = linearScale(sentiment.analyze(giphy.title).comparative);
  // var querySentiment = linearScale(sentiment.analyze(giphySearchTerm).comparative);
  // currentSentiment = (titleSentiment + querySentiment) / 2;

}

function getGifGlowStyle (gifSentiment, is_sticker) {
  if (is_sticker) {
    return 'filter: drop-shadow(0 0 10px' + getSentimentColourCode(gifSentiment)  +');'
  } else {
    return 'box-shadow: 0 0 52px 5px ' + getSentimentColourCode(gifSentiment) + '; '
  }
}

function checkGiphyScrollEnd (event) {
    var element = event.target;
     const scrollTop = element.scrollTop;
      const scrollHeight = element.scrollHeight;
      const clientHeight = element.clientHeight;
      const scrollPosition = scrollTop + clientHeight;
      // Check if the user has scrolled to the end of the element
      if (scrollPosition >= scrollHeight) {
        handlePageGiphy()
      }
}

var handleClickSelectedGiphy = async () => {
  selectedGiphy = '';
  // currentSentiment = null;
}

function linearScale(oldValue) {
  var oldMin = -5;
  var oldMax = 5;
  var newMin = -1;
  var newMax = 1;
  const newValue = ((oldValue - oldMin) / (oldMax - oldMin)) * (newMax - newMin) + newMin;
  return newValue;
}


let showAnalyticsDialog = false

let showShareDialog = false;
let showSnackbar = false;
function copyBoardLink() {
  var copyText = document.getElementById("boardURL")
  copyText.select();
  copyText.setSelectionRange(0, 99999); /* For mobile devices */
  navigator.clipboard.writeText(copyText.value);
  showSnackbar = true
}

function getEmojiStyle (noChars) {
  var windowsOS = navigator.appVersion.indexOf('Win') != -1;

  switch (true) {
    case noChars == 1:
      return 'font-size: 66px; line-height:98px';
      break;
    case noChars < 5  && windowsOS:
      // return 'font-size:36px; line-height:50px;'
      return 'font-size:34px; line-height:46px;'
      break;
    case noChars < 5:
      // return 'font-size:48px; line-height:55px;'
      return 'font-size:44px; line-height:52px;'
      break;
    case noChars < 10 && windowsOS:
      return 'font-size:24px; line-height:30px;'
      break;    
    case noChars < 10:
      return 'font-size:32px; line-height:34px;'
      break;
    case noChars < 21:
      return 'font-size:22px; line-height:24px;'
      break;
    case noChars < 31:
      return 'font-size:12px; line-height:14px;'
      break;
    default:
      return 'font-size:' + 180 / noChars + 'px; line-height:10px;'
  }
}

function getStickerStyle(noChars) {
  var windowsOS = navigator.appVersion.indexOf('Win') != -1;

  function calculateHeight(fontSize, lineHeight) {
    // Assuming the sticker's height should match the emoji's visual area,
    // which might be slightly larger than the font size due to the line height.
    // This calculation can be adjusted based on how stickers are visually compared to text.
    return Math.max(fontSize, lineHeight - (lineHeight - fontSize) / 2);
  }

  switch (true) {
    case noChars == 1:
      return 'height: 82px;'; // Adjusted from 66px font size for visual parity
    case noChars < 5 && windowsOS:
      return 'height: ' + calculateHeight(34, 46) + 'px;';
    case noChars < 5:
      return 'height: ' + calculateHeight(44, 52) + 'px;';
    case noChars < 10 && windowsOS:
      return 'height: ' + calculateHeight(24, 30) + 'px;';
    case noChars < 10:
      return 'height: ' + calculateHeight(32, 34) + 'px;';
    case noChars < 21:
      return 'height: ' + calculateHeight(22, 24) + 'px;';
    case noChars < 31:
      return 'height: ' + calculateHeight(12, 14) + 'px;';
    default:
      // For a dynamic approach similar to emojis, you might base the height directly
      // on the formula used for font size in the original function. This example uses
      // a simplified version for readability.
      var baseHeight = 180 / noChars;
      return 'height: ' + Math.max(baseHeight, 10) + 'px;'; // Ensure a minimum height
  }
}


function scrollToEmojiCategory (catName) {
  let e = document.getElementById(catName);
        e.scrollIntoView({
          block: 'start',
          behavior: 'smooth',
          inline: 'start'
        });
}


const handleCopyChartToClipboard = async () => {
      const image = document.getElementById('sentimentChartZoom');
      const canvas = document.createElement('canvas');
      canvas.width = image.width;
      canvas.height = image.height;
      const context = canvas.getContext('2d');
      context.drawImage(image, 0, 0);
      canvas.toBlob(function(blob) {
        const item = new ClipboardItem({'image/png': blob});
        navigator.clipboard.write([item]).then(function() {
          console.log('Image copied to clipboard!');
          showSnackbar = true;
        });
      });
    }


    let showAssistanceDialog = false;
    let assistanceContent = '';
    let summaryContent = '';
    let summaryTrendContent = '';
    // let summarySentenceStarter = ''
    //  $: { 
    // if (currentInstance && currentInstance.avg_sentiment_score < -0.1) {
    //     summarySentenceStarter = 'Oh dear... ';
    //   } else if (currentInstance && currentInstance.avg_sentiment_score  >= -0.1 && score <= 0.1) {
    //     summarySentenceStarter = 'Hmmm.... ';
    //   } else if (currentInstance &&  currentInstance.avg_sentiment_score >= 0.1) {
    //     summarySentenceStarter = 'Congratulations ';
    //   } else {
    //     summarySentenceStarter =  'Well.... '
    //   }
    // }

  let mergedData;
   $: {
    let boardInstanceMap = new Map();
    boardInstances.forEach(bi => boardInstanceMap.set(bi.id, bi));

    mergedData = attendees.map(attendee => {
      let attendeeMoods = moods.filter(mood => mood.attendee_id === attendee.id);
     
      attendeeMoods = attendeeMoods.map(mood => {
        let {id, created_at, attendee_id, board_id, board_instance_id, ...otherProperties} = mood;  
        let boardInstance = boardInstanceMap.get(mood.board_instance_id);
        return {date: boardInstance ? boardInstance.date : null, ...otherProperties};
      });

      // Sort the moods by date in descending order and take the first 10
      attendeeMoods.sort((a, b) => (b.date ? new Date(b.date) : 0) - (a.date ? new Date(a.date) : 0));
      attendeeMoods = attendeeMoods.slice(0, 1);

      return {name: attendee.name, moods: attendeeMoods};
    });
  }
    let formattedAssistanceContent =''
    $: {
      formattedAssistanceContent = marked(assistanceContent);
    }

    const getAssistance = async () => {
      formattedAssistanceContent = '';
      assistanceContent = '';
      summaryContent = '';
      summaryTrendContent = '';
      showAssistanceDialog = true;

      // Merge Mood board data
      // let mergedData = mergeBoardData();

      // Send data to AI function 
      fetchDataAndUpdateVariable('/api/hello', anonymizeData(mergedData), 'SUGGESTIONS', chunk => {
          assistanceContent += wrapEmojisInSpan(chunk); // Update assistanceContent with the latest chunk
          let endSegmentSize = 30;  // Or however large you want your end segment to be
          let endSegmentStart = Math.max(0, assistanceContent.length - endSegmentSize);
          let endSegment = assistanceContent.slice(endSegmentStart);

          // Check the end segment for anonymized usernames and replace them
          for (let [dummyName, originalName] of Object.entries(nameMapping)) {
              // console.log('dummyName:', dummyName, 'originalName:', originalName); // Debug line
              let regex = new RegExp(dummyName, 'gi');  // 'i' makes the match case-insensitive
              endSegment = endSegment.replace(regex, originalName);
              // console.log('endSegment after replacement:', endSegment); // Debug line
          }

          // Replace the end segment of assistanceContent with the modified end segment
          assistanceContent = assistanceContent.slice(0, endSegmentStart) + endSegment;
    
      });

        fetchDataAndUpdateVariable('/api/hello', mergedData, 'SUMMARY', chunk => {
            summaryContent += chunk; // Update assistanceContent with the latest chunk
        });

        var chartData =  boardInstances.map(item => ({
            date: item.date,
            avg_sentiment_score: item.avg_sentiment_score,
            emoji: item.test_emoji ? item.test_emoji.join('') : ''
        }));
        fetchDataAndUpdateVariable('/api/hello', chartData, 'TREND_SUMMARY', chunk => {
            summaryTrendContent += chunk; // Update assistanceContent with the latest chunk
        });
    }

    async function fetchDataAndUpdateVariable(targetURL, boardData, mode,callback) {
      const edgeResponse = await fetch(targetURL, {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
          },
          body: JSON.stringify({
              "boardData": boardData,
              "mode": mode,
          }),
      });

      const data = edgeResponse.body;
      if (!data) {
          return;
      }

      const reader = data.getReader();
      const decoder = new TextDecoder();
      let done = false;

      while (!done) {
          const { value, done: doneReading } = await reader.read();
          done = doneReading;
          const chunkValue = decoder.decode(value);
          callback(chunkValue);
      }
    }

    let nameMapping = {};
    function anonymizeData(data) {
      let anonymizedData = JSON.parse(JSON.stringify(data));  // This is a common way to deep copy in JS   
      for (let i = 0; i < anonymizedData.length; i++) {
          let originalName = anonymizedData[i].name;
          let dummyName = `user${i+1}`;
          nameMapping[dummyName] = originalName;
          anonymizedData[i].name = dummyName;
      }
      // return [anonymizedData, nameMapping];
      return anonymizedData;
    }

    function wrapEmojisInSpan(str) {
        const regex = emojiRegex();
        return str.replace(regex, '<span class="emoji-cat">$&</span>');
        }

    function mergeBoardData() {
      let boardInstanceMap = new Map();
      boardInstances.forEach(bi => boardInstanceMap.set(bi.id, bi));
      let combinedArray = attendees.map(attendee => {

          let attendeeMoods = moods.filter(mood => mood.attendee_id === attendee.id);
          attendeeMoods = attendeeMoods.map(mood => {
              let {id, created_at, attendee_id, board_id, board_instance_id, ...otherProperties} = mood;  
              let boardInstance = boardInstanceMap.get(mood.board_instance_id);
              return {date: boardInstance ? boardInstance.date : null, ...otherProperties};
          });

          // Sort the moods by date in descending order and take the first 10
          attendeeMoods.sort((a, b) => (b.date ? new Date(b.date) : 0) - (a.date ? new Date(a.date) : 0));
          attendeeMoods = attendeeMoods.slice(0, 10);

          return {name: attendee.name, moods: attendeeMoods};
      });
      return combinedArray;
    }

    // Override the existing code renderer
    const renderer = new marked.Renderer();
    renderer.code = function(code, infostring, escaped) {
      // Return the original content without any modification
      return code;
    };

    marked.setOptions({ renderer });

  // Right bar scripts
  let showIdeaBar = false;

  let showIdeaDialog = false;
  let editIdeaTheme = '';
  let editIdeaText = ''
  function displayIdeaDialog(theme) {
    editIdeaTheme = theme.emoji + theme.name;
    showIdeaDialog = true;
  }

  function expandCollapseIdeaBar () {
    showIdeaBar = !showIdeaBar;
    setUrlParameter('showIdeas',showIdeaBar)
  }

  const generateIdea = async () => {
       // Get the highest current id
      const highestId = Math.max(...currentInstanceIdeas.map(idea => Number(idea.id)));

      // If there are no ideas or the ids are not numbers, highestId will be -Infinity. 
      // So, use 0 as the default in that case.
      const newId = (highestId !== -Infinity ? highestId : 0) + 1;

       let newIdea =  {
        "id": newId,
        "board_instance_id": "",
        "idea_text": '',
        "idea_emoji": "🍩",
        "idea_themes": [{'emoji':'🤪', 'name': 'Fun'}],
        "idea_status": "Proposed",
        "idea_votes": 0
    };
    
    currentInstanceIdeas = [...currentInstanceIdeas, newIdea];

    await new Promise(resolve => setTimeout(() => {
        // newIdea.idea_text = 'Buy some doughnuts for the team! 😃';
         typewriterEffect(newIdea, 'Buy some doughnuts for the team! 😃').then(resolve);
        // This reassignment should notify Svelte about the change
        // currentInstanceIdeas = [...currentInstanceIdeas];

        resolve();
    }, 1000));
  }

  const typewriterEffect = (idea, text) => {
    return new Promise(async (resolve) => {
        for (let i = 0; i < text.length; i++) {
            idea.idea_text += text[i];
            currentInstanceIdeas = [...currentInstanceIdeas];  // Notify Svelte about the change
            await new Promise(r => setTimeout(r, 100));  // Delay for typewriter effect (e.g., 100ms per character)
        }
        resolve();
    });
};


  const handleConfirmUpdateIdea = async () => {
    showIdeaDialog = false;
    let newIdea =  {
        "id": "1",
        "board_instance_id": "",
        "idea_text": editIdeaText,
        "idea_emoji": "☕️",
        "idea_themes":[{'emoji':'😴', 'name': 'Tiredness'}],
        "idea_status": "Proposed",
        "idea_votes": 0
    };
   currentInstanceIdeas = [...currentInstanceIdeas, newIdea];
  }

  function incrementVote(idea) {
    idea.idea_votes += 1;

    // This reassignment will notify Svelte about the change
    currentInstanceIdeas = [...currentInstanceIdeas];
}

  // Ideas Scripts
  let currentInstanceIdeas = [
    // {
    //     "id": 1,
    //     "board_instance_id": 101,
    //     "idea_text": "Take a team coffee break to moan about the weather 😃",
    //     "idea_emoji": "☕️",
    //     "idea_themes": ["tiredness","weather"],
    //     "idea_status": "Proposed",
    //     "idea_votes": 3
    // } 
    // ,
    // {
    //     "id": 2,
    //     "board_instance_id": 101,
    //     "idea_text": "Offer to work with your colleague on a trask if they are struggling. ",
    //     "idea_emoji": "🧰",
    //     "idea_themes": ["Workload"],
    //     "idea_status": "Proposed",
    //     "idea_votes": 1
    // }
    ];

$: sortedIdeas = [...currentInstanceIdeas].sort((a, b) => b.idea_votes - a.idea_votes);



let currentInstanceThemes = [
  {'emoji':'🤝', 'name': 'Offer Help'},
  {'emoji':'🏃🏻‍♀️', 'name': 'Workload'},
  {'emoji':'😴', 'name': 'Tiredness'},
  {'emoji':'🤪', 'name': 'Fun'}
  ];
    

  let clicked = false;
  let drawerOpen = false;

  let showReminderForm = false;

  function editReminder() {
    showReminder = true;
  }

  async function handleSaveReminder(event) {
  const data = event.detail;

  const weekdayMap = {
    Sunday: 0, Monday: 1, Tuesday: 2, Wednesday: 3,
    Thursday: 4, Friday: 5, Saturday: 6
  };

  // Transform data safely for Supabase
  const transformedData = {
    ...data,
    day_of_week: data.frequency === 'weekly' && data.day_of_week
      ? weekdayMap[data.day_of_week]
      : null,
    day_of_month: data.frequency === 'monthly' && data.day_of_month
      ? parseInt(data.day_of_month)
      : null
  };

  try {
    if (reminder) {
      // UPDATE
      const { error } = await supabase
        .from('reminders')
        .update(transformedData)
        .eq('id', reminder.id);

      if (error) throw error;
      reminder = { ...reminder, ...transformedData };

    } else {
      // INSERT
      const { data: newData, error } = await supabase
        .from('reminders')
        .insert([{ ...transformedData, board_id: thisBoard.id, owner_id: $user.id }])
        .select()
        .single();

      if (error) throw error;
      reminder = newData;
    }

    showReminderForm = false;

  } catch (err) {
    console.error('Reminder save failed:', err.message);
    // Optionally show UI error here
  }
}

let showUpgradeDialog = false;

function displayUpgradeDialog (click_source) {
  if (!showUpgradeDialog) {
    showUpgradeDialog = true;
    if (typeof gtag !== 'undefined') {
        gtag('event', 'upgrade_view_options_dialog', {
          // upgrade_click_source: click_source
          upgrade_click_source: click_source
        });
        window.clarity("event", "upgrade_view_options_dialog")
    }
  } else {
    showUpgradeDialog = false;
  }
}
 
</script>
<svelte:head>
  <meta property="og:title" content="{thisBoard.title}" />
  <meta property="og:description" content="How are you feeling?">
</svelte:head>

<!-- Page Header -->
<header>
  <a href="/" style="display:flex">
    <img src="/images/smallLogo.png" style="align-self:center" alt="MoodFirst Logo"/>
  </a>

  <!-- display title in header when in board mode -->
  {#if boardMode == 'BOARD'}
    <div class="boardTitle-boardMode">{thisBoard.title ? thisBoard.title : ''}</div>
  {/if}
  {#if betaFeaturesEnabled} <MaterialApp><a href="/beta"><Chip class="ma-2" primary-color>Beta</Chip></a></MaterialApp>{/if}
  <div style="margin-left: auto; margin-right: 6%; display:flex; flex-direction: row;    align-items: center;">

    <div id="settings-tooltip" class="tooltip tooltip-bottom mr-2" data-tip="Show Upgrade Options">  
      <button class="btn btn-xs !border-[var(--aqua)] !border-1 text-white mb-0 
                     bg-[var(--aqua)] hover:bg-[var(--aqua)] hover:text-white transition-colors duration-300" on:click={() => displayUpgradeDialog('board_menu_upgrade_button')}> 
        <span class="text-3xl -mr-1 mb-2">🚀</span>Upgrade Board
      </button>
    </div>

    {#if $user}

    <div id="settings-tooltip" class="tooltip tooltip-bottom mr-2" data-tip="Board Settings" on:click={() => drawerOpen = true}>
      <button class="btn btn-xs bg-white !border-[var(--aqua)] !border-1 text-[var(--aqua)] mb-0  
                     hover:bg-[var(--aqua)] hover:text-white transition-colors duration-300">
        <Settings2 class="w-4 h-4" /> 
        Board Settings
      </button>
    </div>


    <div id="close-tooltip" class="tooltip tooltip-bottom" data-tip="Close Board">
      <a href="/myBoards">
        <button class="btn btn-xs bg-white !border-[var(--aqua)] !border-1 text-[var(--aqua)] mb-0 mr-2 
                       hover:bg-[var(--aqua)] hover:text-white transition-colors duration-300">
          <X class="w-4 h-4 stroke-3"/> 
        </button>
      </a>
    </div>

    <!-- <div id="close-tooltip" class="tooltip tooltip-bottom" data-tip="Close Board">
      <a href="/myBoards"  class="flex items-center" style="margin-right: 10px; cursor: hand" >
        <SquareX class="w-7 h-7 text-[var(--aqua)]"/>
      </a>
    </div>  -->

    <UserMenu  user={user}   on:SignOut={handleSignOut}/>
    <!-- <Menu hover nudgeX="200px" >
      <div slot="activator">
        <Avatar size="36px" class="Xprimary-color" style="background-color:var(--blue); color: white">{userInitials}</Avatar>
      </div>
      <List>
        <ListItem on:click={navMyBoards} style="background-color:white">My Boards</ListItem>
        <ListItem on:click={handleSignOut} style="background-color:white">Sign Out</ListItem>
      </List>
    </Menu> -->
    {:else}
      <a style="margin-left: auto; margin-right: 60px" href="/login?redirect={document.location.href}">Login</a>
    {/if}
  </div>

</header>


<!-- Board Header -->
{#if boardMode == 'GRID'  || 1 < 2}
<div class="boardHeader" 
  style="
  transition: background-color 2s; 
  transition-timing-function: linear; 
  Xbackground-Color:{boardMode == 'GRID' ? getSentimentColourCode(currentInstanceSentiment) : 'white'};
  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0) 150px, rgba(255, 255, 255, 1));
    Xbackground-blend-mode: overlay;
/*  background-image: linear-gradient( {getSentimentColourCode(currentInstanceSentiment)},white);*/
  min-height:190px; color:white; Xdisplay: flex; align-items: center; flex-direction: row; align-items: flex-start; justify-content: space-between; padding-bottom: 40px">


  <div id="color-fade" style="width: 100%;   background-Color:{boardMode == 'GRID' || 1 < 2 ? getSentimentColourCode(currentInstanceSentiment) : 'white'};
  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0) 28px, rgba(255, 255, 255, 1));padding-left: 6%; padding-right: 6%; min-height: 90px; display: flex; align-items: flex-end;">

    <Editable user={$user} value={thisBoard.title} on:save={e => handleSaveBoardTitle(e.detail)} on:not-owner={e => handleUpdateBoardNotOwner(e.detail)}>
      <div class="boardTitle" style="outline:none !important; transition: color 1s;  Xcolor:{parseFloat(currentInstanceSentiment) > 0.2 || boardMode =='BOARD'? 'black' : 'white'}">{thisBoard.title ? thisBoard.title : ''}
      </div>
    </Editable>
  
  </div>

  <!-- Tabs for Team Mood Check and Team Goals-->
 <!--  <div class="tab-temp-container">

   <div class="tab-bar">
    <div class="tab active-tab">Team Mood Check-In</div>
    <div class="tab">Set your Team's Goals</div>
  </div>

  </div> -->
  <!-- End of Tabs -->
 
  <!-- Flex layout -->
  <div style="display: flex; align-items: center; flex-direction: row; align-items: flex-start; justify-content: space-between;padding-left: 6%; padding-right: 6%; margin-top: -40px">



  <!-- Board Question -->
  <div style="Xmargin-top: -20px; display: flex; align-items: center; flex-direction: column; align-items: flex-start; align-self: center;">





    {#if displayBoardQuestion}
    <!-- <Editable user={$user} value={thisBoard.question} > -->
     <div  in:fly="{{ x: -150, duration: 1200 , delay: 600, easing: quintOut}}" style="outline:none !important; transition: color 1s; Xcolor:{parseFloat(currentInstanceSentiment) > 0.2 || boardMode =='BOARD'? 'black' : 'white'}" class="boardQuestion">{thisBoard.question && thisBoard.question!='' ? thisBoard.question : 'What\'s your mood today?'}</div>
    <!-- </Editable> -->
    {/if}

  </div>
    

 <div style="background-color: white; align-self: center; border-radius: 5px;">
 </div>

 <div style="align-self: center; background-color: white; border-radius: 5px; padding: 8px 8px 0px 8px">
   
   <!-- QR Code -->
    <DeviceDetector showInDevice="desktop">
    <div id="ShareBoard" style="cursor: pointer; text-align: center" on:click="{e => showShareDialog = true}">
      <QRCode elementID="pageQRCode" codeValue="{document.location.href.replace('&trialBoard=yes','')}" squareSize="80"/>
      <span><a href="#" style="font-weight: bold">
        Share
        <Icon data={faShare} scale="1.2" style="color: var(--aqua) !important; margin-left: auto; cursor: hand; position: relative; top: 4px" />

      </a></span>
    </div>
    </DeviceDetector>
 </div>

</div> <!-- end of flex layout -->

</div><!-- End of header -->

<div style="display: none; Xdisplay:flex; margin-left: 6%; margin-right: 6%; align-items: center; margin-top:30px">
  <div style="flex-grow:1">
    <!-- <div class="boardQuestion">{thisBoard.question && thisBoard.question!='' ? thisBoard.question : 'What\'s your mood today?'}</div> -->
  </div>
    <div style="flex-grow:1; height: 110px;
      line-height: 110px;">
  {#if !boardHasOwner}
    <Button id="SaveTrialBoardButton" class="primary" on:click={open}>
      Save Board
    </Button>
  {/if}

  <!-- Chart -->
<!--   {#if boardInstances.length > 1  && boardHasOwner}
    <div style="margin-left: 20px; height: 10vh; width: 18vw; cursor: zoom-in"  on:click="{e => showAnalyticsDialog = true}" title="Click to Zoom">
        <MoodSentimentCart boardInstances={boardInstances} moods={moods} />
    </div>
  {/if} -->
  <!-- <div>chartLabels:{chartLabels}</div>
  <div>chartDataSet:{chartDataSet}</div> -->

  </div>

  <!-- QR Code and Share link -->
 <!--  <DeviceDetector showInDevice="desktop">
    <div id="ShareBoard" style="cursor: pointer; text-align: center" on:click="{e => showShareDialog = true}">
      <QRCode elementID="pageQRCode" codeValue="{document.location.href.replace('&trialBoard=yes','')}" squareSize="100"/>
      <span><a href="#" style="font-weight: bold">
  Share
        <Icon data={faShare} scale="1.2" style="color: var(--aqua) !important; margin-left: auto; cursor: hand; position: relative; top: 4px" />

      </a></span>
    </div>
  </DeviceDetector> -->

</div>
{/if}
    <!-- Row for Board Controls,  Empty State and Validation Error -->
    <div class="board-controls-row" style="height: 50px; display: flex; Xmargin-top: 8px; margin-top: -20px">

    <!-- Switch board Mode -->
    {#if attendees.length > 0}
      &nbsp;
      
      <div title="Switch Mode" style="margin-right: 24px">
      <Switch bind:checked={boardMode} inset color="#34C7C8" on:change={e=> {handleChangeBoardMode(event.srcElement.checked)}}
        class="switch-board-mode" style="color: {boardMode ? 'var(--aqua)' : 'grey' } !important; margin-bottom: 0 !important"
        > Daily View</Switch>
     <!--   <Menu style="z-index:9999">
          <div slot="activator">
          <Button style="box-shadow: none !important; height: 32px !important">
            <Icon data={boardMode ? faSquare : faBorderAll} scale="1.2"  style="color: var(--aqua) !important;"/>
            &nbsp;{boardMode ? 'Daily View' : 'Grid View'}
          </Button>
          </div>
          <List>
            <ListItem on:click={ e=> {handleChangeBoardMode(false)}} active={boardMode ? null : true}>
              <Icon data={faBorderAll} scale="1.2" style="color: var(--aqua) !important; margin-left: auto; cursor: hand; position: relative; top: 4px" />
              <b>Grid View</b> (view multiple days)
            </ListItem>
            <ListItem Xon:click={e=>{boardMode='BOARD'}} on:click={ e=> {handleChangeBoardMode(true)}} active={boardMode ? true : null}>
              <Icon data={faSquare} scale="1.2" style="color: var(--aqua) !important; margin-left: auto; cursor: hand; position: relative; top: 4px" on:click={handleChangeBoardMode}/>
              <b>Daily View</b> (focus on today)
            </ListItem>
          </List>
      </Menu> -->
      </div>
    {/if}
    
      {#if boardMode && attendees.length > 0}
        <!-- Current Date (board mode) -->
        {#if boardInstances.indexOf(currentInstance) < boardInstances.length - 1 || hasNextPage} 
        <div class="board-date-nav icon-action " title="Previous Date"  on:click={handleClickPreviousDate}><Icon data={faChevronLeft} scale="1.1" /></div>  
        {:else}
         <div class="board-date-nav-disabled icon-action"><Icon data={faChevronLeft} scale="1.1" /></div>
        {/if}
        <div class="date-wrapper">
          <div class="board-disp-current-day">{currentInstance ? moment(currentInstance.date).format("dddd") : '' } -&nbsp;</div>
          <!-- <div class="board-date-spacer"> - </div> -->
          <div class="board-disp-current-date">{currentInstance ? moment(currentInstance.date).format("MMM Do YYYY") : '' }</div>
        </div>
       {#if boardInstances.indexOf(currentInstance) > 0 || hasPreviousPage} 
        <div class="board-date-nav icon-action" on:click={handleClickNextDate} title="Next Date" ><Icon data={faChevronRight} scale="1.1" /></div>    
        {:else}
        <div class="board-date-nav-disabled icon-action"><Icon data={faChevronRight} scale="1.1" /></div>
       {/if} 

      {/if}

        <!-- Add Attendee Icon (board mode) -->
        {#if (boardMode) && (!showAddAttendeeForm)}
        <div class="icon-action" title="Add Attendee" style="margin-left: 24px; margin-bottom: 6px;Xmargin-left: 12px; margin-bottom: auto; margin-top: 8px; Xposition: relative; Xleft: -43px;" on:click={ (e) => {showAddAttendeeForm = !showAddAttendeeForm }} >
         <Icon data={faUserPlus} scale="1.4" style="color: var(--aqua) !important; cursor: hand"/>
        </div>
        {/if}
        
        <!-- Add Attendee Form (board mode) -->
        {#if showAddAttendeeForm && boardMode}
          <form on:submit|preventDefault={handleAddAttendee}>
            <input autofocus type="text" bind:value={NewAttendeeName} placeholder="Attendee name" style="border: 1px solid #969696; margin-left:14px; margin-right:0px ;width: 140px" on:input={() => {displayAddAttendeeErrror=''; showAddAttendeeFormError = false;}}/>
              <Button class="primary" type="submit">Add</Button>&nbsp
          </form>
        {/if}

        <!-- Chart -->
        <!-- <Tooltip bottom> -->
        {#if !showAddAttendeeForm}
        <div class="{(showAssistanceDialog || showAnalyticsDialog)? '' : 'zoomableInsights'}" style="cursor: pointer !important;margin-left:24px; padding-right: 12px" on:click={betaFeaturesEnabled ? getAssistance:(e => showAnalyticsDialog = true) } >
          <div style="display: flex; flex-direction: row;align-items: center;"> 

          <!-- Gauge (board mode) -->
          {#if boardMode && attendees.length > 0}
            <div style="margin-top:-20px">
             <Speedometer width={120} height={60} minValue={-0.52} maxValue={0.8}
                value={(currentInstance && currentInstance.avg_sentiment_score) ? currentInstance.avg_sentiment_score : 0.14} 
                XneedleColor="#255991" labelFontSize={0} ringWidth={12} needleTransition="easeElastic" needleTransitionDuration={6666}
                segments={11}
                segmentColors={['#DA1A0F', '#E85E37', '#EA683C','#F29053','#ECAB60','#439D37','#87B824','#AACD6F','#E8E88F','#FCF275','#FFF60D']} needleHeightRatio={0.55}/>
            </div>
          {/if}
          
          <div style="background-color: #ffffff00; align-self: center; border-radius: 5px; ">
            {#if boardInstances.length > 1  && boardHasOwner}
              <div style="margin: 8px; Xheight: 8vh; width: 15vw; Xcursor: zoom-in"  Xon:click="{e => showAnalyticsDialog = true}">
                  <MoodSentimentCart boardInstances={boardInstances} moods={moods} />
              </div>
            {/if}
          </div>
          
          <!-- Get suggestions from ChatGPT -->
         <!--  {#if betaFeaturesEnabled }
            <div  on:click={getAssistance} style="margin-left:12px">
             <Icon data={faLightbulb} scale="1.6" style="color: var(--aqua) !important; margin-left: auto; cursor: hand; Xposition: relative; Xtop: 11px"  />
            </div>
          {/if} -->
        </div>
        {#if betaFeaturesEnabled}
        <div class="insightsMessage typewriter">
          <Icon data={faLightbulb} scale="1.2" style="color: var(--aqua) !important;"  />
          Get Team insights & suggestions...
        </div>
        {/if}
        </div>
        {/if}
     <!--    <span slot="tip" style="background-color: #8AE3C7;">Team Insight & Suggestions</span>
        </Tooltip> -->

      <!-- Attendee Form validation errors -->
      <Snackbar outlined class="form-error" bind:active={showAddAttendeeFormError} center timeout={5000}>
          {displayAddAttendeeErrror}
      </Snackbar>


      {#if attendees.length == 0 && displayAddAttendeeErrror == ''}
        <div class="emptyStateMessage" in:scale="{{ y: 200, duration: 1000, delay: 2000 }}" >
          <img src="/images/emptyStateArrow.png" style="width:108px;height: 41px; align-self: flex-end;" alt="Arrow showing how to get started"/>
          <span style="margin-left: 6px; font-weight: bold; margin-top: -4px">Add your team to the board</span>
        </div>
      {/if}

      <div style="margin-left: auto; margin-right: 120px">
        {#if !boardHasOwner && attendees.length > 0}
          <span  on:click={open} in:fade="{{ y: 200, duration: 1000, delay: 800 }}">
            <Button id="SaveTrialBoardButton" class="primary">
              <!-- <Icon data={faSave} scale="1.4" style="color: white;  margin-left: auto; cursor: hand" /> &nbsp; -->
              Save your Board          
            </Button>
          </span>
        {/if}
      </div>

    </div> <!-- End of row for Board Controls -->

    {#if debugMode}
    <div class="debug">
      <div>pageSize: {pageSize}</div>
      <div>page: {page}</div>
      <div>isLoading: {isLoading}</div>
      <div>hasNextPage: {hasNextPage}</div>
      <div>hasPreviousPage: {hasPreviousPage}</div>
    </div>
    {/if}

    <!-- Sroll Controls -->
      <div style="position: relative; width: 100%; height: 0px;z-index: 9999;"> 
         {#if gridScrollable && !boardMode}
        <div class="icon-action" title="Scroll Left" style="position: absolute; top: 10px; right: {showIdeaBar ? '2.5%' : '2.5%'};" on:click={(event) => { document.getElementById('scroll-mood-grid').scrollBy({left: 440,behavior: 'smooth'});}}>
          <!-- Change right: to 4.5% when enabling right panel-->
          <Icon data={faChevronRight} scale="1.2"  style="color: var(--aqua) !important;"/>
        </div>
        <div class="icon-action" style="position: absolute; top: 10px; left: 2.5%;
            text-align: center;" on:click={(event) => { document.getElementById('scroll-mood-grid').scrollBy({left: -440,behavior: 'smooth'});}}>
          <Icon data={faChevronLeft} scale="1.2"  style="color: var(--aqua) !important;"/>
        </div>
        {/if} 
      </div>

      <!-- Mood Board: Grid & Board Mode -->
      <div id="board-rightpanel-flex-layout" style="display: flex; flex-direction: row">

      <div id="{boardMode ? 'board-container' : 'scroll-mood-grid'}" style="transition: flex-basis 0.5s;flex-basis:{'25%' ? '75%' : '95%'}" bind:this={gridElement}>

      <div id="mood-board" style="{boardMode ? 'margin-top: 6px;' : ''}">
          
      <!-- Header Row (shown in grid only)  -->
      <div class="boardTableHeaderRow {boardMode ? 'collapse-vertical-hide' : ''}" bind:clientWidth={gridContentWidth}>

      <!-- Add Attendee Form -->
      <div class="boardTableCell {boardMode ? 'collapse-vertical-hide' : ''}" style="Xwidth: 280px">
        {#if !boardMode}
        <form on:submit|preventDefault={handleAddAttendee} class="{boardMode ? 'collapse-vertical' : ''}" style="min-width: 250px;">
          <input id="NewAttendeeNameField" class="input input-bordered w-full border-[var(--aqua)] focus:ring-0 focus:outline-none focus:border-[var(--aqua)]" type="text" bind:value={NewAttendeeName} placeholder="Attendee name" style="border: 1px solid #969696; margin:10px; width: 140px" on:input={() => displayAddAttendeeErrror=''}/>
          <Button class="primary" type="submit">Add</Button>&nbsp
        </form>
        {/if}
      </div> 

    <!-- Attendee name column headers (grid mode only) -->     
     {#each attendees as attendee}
        {#if !boardMode} 
        
        <div class="boardTableCell colHeader {boardMode ? 'collapse-vertical-hide' : ''}" style = "width:190px">

          <Tooltip bottom>
            <span class="delete-attendee" on:click={() => showConfirmDeleteAttendee({attendeeID: attendee.id, name: attendee.name})} >
                <Icon data={faUserMinus} scale="1.5"  style="cursor: hand;"/>
            </span>       
            <span slot="tip">Remove this Attendee</span>
          </Tooltip>

          {attendee.name}
      </div>
      {/if}
    {/each}

    <!-- Empty State Attendee names  -->
    {#if attendees.length == 0}
    {#each Array(3) as _, i}
      <div class="boardTableCell colHeader text-center" style = "width:190px">
        <img src="/images/attendeeEmptyState.jpeg" class="mx-auto" style="width:108px; vertical-align: middle;" alt="Attendee name placeholder" />
      </div>
    {/each}
    {/if}

    </div> <!-- End of Header row -->

    <!-- For each date instance (only show current date in board mode) -->
    {#each displayInstances as instance, idx}

    <!-- Row for each date  / board mode -->
    <div class="{boardMode ? 'boardLayout' :'boardTableRow'}"> 
          
      <!-- Date column  (grid mode only) -->
      <div class="boardTableCell date-cell {boardMode ? 'collapse-hide' : ''}" class:currentDate="{moment(instance.date).isSame(new Date(), 'day')}"> 

      <div class="flex items-center">

         <!-- Delete Date icon-->
        <Tooltip bottom>
          <span class="delete-date" on:click={() => confirmDeleteDate({ instanceID: instance.id })}>
            <Icon data={faCalendarMinus} scale="1.5" class="cursor-pointer"/>
          </span>
          <span slot="tip">Remove this date</span>
        </Tooltip>

        <!-- Page Up Nav-->
        {#if idx === 0 && hasPreviousPage}
          <a
            href="#" class="text-[var(--aqua)] hover:underline text-sm mx-auto pt-1 cursor-pointer"
            on:click|preventDefault={() => get_board_instances(page - 1)}
            disabled={!hasPreviousPage} 
            >
            <ArrowUp strokeWidth={3} size={18} class="inline-block" />Later Dates
          </a>
        {/if}
      </div>


        {#if !boardMode}

        <div style="display: flex; flex-direction: column">
          {#if debugMode}
          <!-- <div class="debug">instance:{instance ? instance.id : ''}</div> -->
          <div class="debug">avg_sentiment_score: {instance.avg_sentiment_score}</div>
          {/if}
          
          
          <div>{moment(instance.date).format("ddd MMM Do YYYY")}</div>
             <div class="flex flex-row justify-center" style="margin-top:-8px; cursor: pointer" on:click="{e => showAnalyticsDialog = true}">
            <Speedometer
              width={120}
              height={60}
              minValue={-0.52}
              maxValue={0.8}
              value={instance.avg_sentiment_score ? instance.avg_sentiment_score : 0.14}
              needleColor="#255991"
              labelFontSize={0} 
              ringWidth={12}
              needleTransition="easeElastic"
              needleTransitionDuration={6666}
              segments={11}
              segmentColors={['#DA1A0F', '#E85E37', '#EA683C','#F29053','#ECAB60','#439D37','#87B824','#AACD6F','#E8E88F','#FCF275','#FFF60D']}
              needleHeightRatio={0.55}
            />
          </div>

        </div>
        {/if}
        <!-- Page Down Nav -->
        {#if idx === displayInstances.length - 1  && hasNextPage}
        <div class="absolute bottom-0 left-0 right-0 flex justify-center pb-1">
            <a 
              class="text-[var(--aqua)] hover:underline text-sm mx-auto pt-1 cursor-pointer"
              on:click={pageDown}
              disabled={!hasNextPage}
            >
            <ArrowDown strokeWidth={3} size={18} class="inline-block" />Earlier Dates
          </a>
        </div>
        {/if}
      </div>
            

      <!-- Iterate attendees for this date -->
      {#each attendees as attendeeCell}

      <!-- select moods for this attendee on this date  -->
      {@const theseMoods = moods.filter(x => (x.board_instance_id == instance.id || x._instance_date == instance.date)  && x.attendee_id == attendeeCell.id)}
      {@const thisMood = theseMoods[0]}
      <!-- {@const moodEmojiStickers = thisMood ? [...thisMood.mood,...thisMood.mood_stickers] : []} -->
      {@const moodEmojiStickers = (thisMood && thisMood.mood) ? [...thisMood.mood, ...(thisMood.mood_stickers ?? [])] : []}


      <!-- Attendee Table Cell or Card (grid mode) -->
      <div class="boardTableCell mood {(thisMood && !active2) ? 'zoomable' : ''} {windowsOS ? 'windowsOS' : 'MAC'} {boardMode ? 'mood-card' : ''}" on:click={ () => handleClickMood({instance: instance,attendeeCell: attendeeCell})} Xon:click={() => dispatch('clickMood',{instance: instance,attendeeCell: attendeeCell})} Xin:scale="{{ y: 200, duration: 200 }}" >

        <div style="display:flex; flex-direction:column; height: 100%; Xjustify-content: center"> 
          <div class="board-attendee-name {boardMode ? '' :'collapse-vertical-hide' }" >{attendeeCell.name}</div>
           
            {#if debugMode}<div class="debug">sentiment (Gifs): {(thisMood && thisMood.sentiment) ? thisMood.sentiment : ''}</div>
            {/if}

            {#if thisMood && (moodEmojiStickers.length > 0 | thisMood.giphy_url != '')}

              <!-- {#if theseMoods.length < 2} -->
              
              <!-- Display Giphy -->
              {#if thisMood.giphy_url && thisMood.gipyurl != ''}
               <div class="giphy-container">      
                <img alt="Display GIF" class="giphy-img" src="{thisMood.giphy_url}" 
                style={betaFeaturesEnabled ? getGifGlowStyle(thisMood.sentiment, thisMood.giphy_url.includes('stickers')) : '' }
                />
                 <!-- style={betaFeaturesEnabled ? 'box-shadow: 0 0 65px 10px ' + getSentimentColourCode( thisMood.sentiment) + '; border-radius: 44px !important;' :''} -->
               </div>
              {:else}
              <!-- Display Emoji -->
                <div class="emojiBox" >
                 <!-- {#each thisMood.mood as selected} -->
                 {#each moodEmojiStickers as selected}
                  <div class="emoji" style={getEmojiStyle(moodEmojiStickers.length)} transition:scale="{{ duration: 200, easing: cubicOut }}">
                    {#if selected.GifURL }
                       <img alt="Display Gif" class="giphy-img" src={selected.GifURL} 
                        style="{getStickerStyle(moodEmojiStickers.length)}"
                       />
                    {:else}
                      {selected}
                  {/if}
                  
                </div>
                 {/each}
                </div>



                {#if betaFeaturesEnabled}
                <div class="mood-shape" style="background-color: {getSentimentColourCode (thisMood.overall_sentiment)}">
                </div>
                {/if}

              {/if}

              {#if debugMode}
                <div class="debug">overall_sentiment (emoji): {thisMood.overall_sentiment}</div>
              {/if}

              <!-- Display Reason -->
               {#if thisMood && thisMood.reason}

                  <div class="reasonContainerZoom">
                    <!-- <div style="font-size:12px; height: 19px;">
                      <img alt="Speech Bubble" src="/images/SpeechBubbleTriangleGrey50.png" style="position: relative; left:-10px"/>
                    </div> -->
                     <div class="mood-text moodReasonZoom wordwrap" style={betaFeaturesEnabled ? getReasonFont(thisMood.overall_sentiment) : ''}>{thisMood.reason}</div>
                  </div>

                    <div class="reasonContainer">
                    <!-- <div style="font-size:12px; height: 19px;">
                      <img alt="Speech bubble" src="/images/SpeechBubbleTriangleGrey50.png" style="position: relative; left:-10px"/>
                    </div> -->
                     <div class="mood-text moodReason wordwrap" style={betaFeaturesEnabled ? getReasonFont(thisMood.overall_sentiment) : ''}>{thisMood.reason}</div>
                  </div>

                {/if}

              <!--   {:else}
             
                  <MoodStory moodStories={theseMoods}/>
                {/if} -->

            {:else}
            <!-- Empty State (no mood selected) -->
              <img src="/images/defaultMoodIcon.png" height="64px" width="64px" alt="default mood icon" style="vertical-align: middle; margin-left: auto;margin-right: auto;" />
            {/if}

          </div>

        </div> <!-- End of Attendee table cell or card -->
      {/each}

      <!-- Empty State: display 3 empty attendee cells (grid mode only) -->
      {#if attendees.length == 0}
      {#each Array(3) as _, i}
      <div class="boardTableCell mood text-center" >
          <img src="/images/defaultMoodIcon.png" class="mx-auto" height="64px" width="64px" alt="default mood icon" style="vertical-align: middle"/>
      </div>
      {/each}

      {/if}

       </div>

      {/each} <!-- End of each attendee iteration -->

    </div> <!-- End of mood board / grid -->

  </div> <!-- End of scroll conainer -->


  <!-- Right bar -->
  {#if 1==2}
  <div class="rightBar {showIdeaBar ? 'expandedRightBar' : 'collapsedRightBar'}" style="margin-left: auto;">
      
    <div class="ideas-top-bar" on:click={expandCollapseIdeaBar}>
      <span>
        <Icon data={faLightbulb} scale="1.4" style="color: var(--green) !important;"  />
      </span>

      {#if showIdeaBar}
       &nbsp;<span class="suggestions-title">
          ⬆mpro✅ements
      </span>
       <span class="idea-add"><Icon data={faPlus} scale="1.4" style="color: var(--green) !important;"  /></span>
      {/if}
  </div>
   
   <!--  <div class="suggestions-desc">
      Here's some fun suggestions to star the discussion 😃
    </div> -->

    {#if showIdeaBar}

     {#each sortedIdeas as idea (idea.id)}  
      <div class="idea-entry" in:scale animate:flip> 
        <div class="idea-themes-container">
          {#each idea.idea_themes as theme}
            <span>{theme.emoji}</span><span class="idea-theme">{theme.name}</span>
          {/each}
        </div>
        <div class="idea-emoji-text-container">
          <div class="idea-emoji">{idea.idea_emoji}</div>
          <div class="idea-text" contenteditable>{idea.idea_text}</div>
        </div>
        <div class="idea-votes-status-container">
        <div class="votes-container">
          {#each Array.from({length: idea.idea_votes}) as _, i}
            <span class="idea-vote">👍</span>&nbsp;
          {/each}
          <span class="idea-vote action" on:click={() => incrementVote(idea)} style="filter: grayscale(100%);">👍</span>
        </div>
        <div class="idea-status">
           <Icon data={faLightbulb} scale="1" style="color: var(--green) !important;"  />
        </div>
        </div>
      </div>
     {/each} 

  <div class="themes-title">Suggested Themes</div>
  {#each currentInstanceThemes as theme}
    <div class="theme-entry">
      <div class="theme-emoji">{theme.emoji}</div>&nbsp;
      <div class="theme-label">{theme.name}</div>
       <div class="theme-add icon-action-mini" on:click={ () => displayIdeaDialog(theme)}><Icon data={faPlus} scale="1" style="color: var(--green) !important;"  /></div>
      <div class="theme-generate icon-action-mini" on:click={() => generateIdea(theme)}><Icon data={faBrain} scale="1.4" style="color: var(--green) !important;"  /></div>
    </div> 
  {/each}

   <!--  <div class="suggestions-sub-title">       
      <span class="suggestion-emoji">⚡️</span>
      Connect with ....</div>

    <div class="suggestions-container">

      <div class="suggestion-entry">
         <span class="suggestion-text">Marcus, why the 🤕?</span>
      </div>
      <div class="suggestion-entry">
         <span class="suggestion-text">Check if Matt is ok 🤢</span>
      </div>

    </div> -->

  <!--   <div class="suggestions-sub-title">
      <span class="suggestion-emoji">🌐</span>
      Discuss....
    </div>
      <div class="suggestion-entry">
         <span class="suggestion-text">What are the causes of excessive workload in the team?</span>
      </div>
 -->

    <!-- <div class="suggestions-sub-title">
      <span class="suggestion-emoji">🚀</span>
      Team Improvement Ideas
    </div> -->
 <!--    <div class="suggestions-container">
      
      <div class="suggestion-entry">
         <span class="suggestion-text">🔁 Reprioritise items or drop some stories from the current sprint.</span>
      </div>
      
      <div class="suggestion-entry">
         <span class="suggestion-text">🍰  Buy some nice cake for the team .</span>
      </div>

    </div> -->

    {/if}

  </div>
  {/if}
  

</div>

  {#if debugMode}
  <!--  <div class="debug" style="position: fixed; bottom: 0; width: 100%; height: 60px">
      mergedData:{JSON.stringify(mergedData, null, 2)}
      <button class="debug" >Copy</button>
    </div> -->

    <div id="copyDiv" class="debug" style="position: fixed; bottom: 0; width: 100%; height: 60px">
      <button class="debug" on:click={() => {
        const copyText = document.getElementById('copySpan').textContent;
        navigator.clipboard.writeText(copyText);
      }}>Copy</button>
      <span id="copySpan">{JSON.stringify(mergedData, null, 2)}</span>
    </div>

  {/if}


    <!-- Select Mood Dialog  -->
    <Dialog id='select-mood-dialog' bind:active={active2} width="900px">
    <div style="background-color:white; padding-top:15px; padding-bottom:15px; padding-left: 40px; padding-right: 40px; height:500px ">
    <!-- <div class="selectMoodTitle">What's your mood today?</div> -->

    <div style="display:flex; ">
      <div style="width: 72%">
        <div style="display:flex;flex-direction: row; align-items: center;">
          <img src="/images/defaultMoodIcon.png" height="65px" width="65px" alt="default mood icon"/>
          <div>
            <div class="selectMoodTitle">What's your mood today?</div>
          </div>
        </div>
        <!--
        <div id="categoryNavigationBar">
          {#each emojiCategories as emojiCat}
            <span on:click={() => scrollToEmojiCategory(emojiCat)}> {emojiCat}</span>&nbsp;|&nbsp;
          {/each}
        </div>
        -->

        <div class="emojiList" style="flex-grow:1; padding: 6px; Xmargin-right: 15px;">

          {#each emojiCategories as emojiCat}
            <div class="emojiCategoryTitle" id="{emojiCat}">{emojiCat}</div>
            <div class="emojiCateoryContainer" style="display:flex; flex-wrap: wrap">
            {#each emojiInCategories(emojiCat) as emojiInCat}
              <div class="chooseEmoji" style={betaFeaturesEnabled? 'background-image: radial-gradient(circle,'+  getSentimentColourCode(emojiInCat.SentimentScore)+ ', white); background-color:' : ''} on:click={e => handleClickEmoji(emojiInCat.Emoji)}>{emojiInCat.Emoji}</div>
            {/each}
            </div>  
            <div class="emojiCateoryContainer" style="display:flex; flex-wrap: wrap">
            {#each gifsInCategories(emojiCat) as gifInCat}
              <div class="mood-text-gif" on:click={ e => handleSelectSticker(gifInCat)}>
                 <img alt="Mood description" class="mood-description-gif-img" src={gifInCat.GifURL}  
                  style={betaFeaturesEnabled ? getGifGlowStyle(gifInCat.SentimentScore, true) : '' } 
                title={debugMode ? gifInCat.SentimentScore : ''}>
            </div>

            {/each}
            </div>
          {/each}

          {#if previouslyAddedEmoji}
            <div class="emojiCategoryTitle">Recently Added</div>
            <div style="display:flex; flex-wrap: wrap; max-width: 440px">
            {#each previouslyAddedEmoji as prevEmoji}
              <div class="chooseEmoji" 
              on:click={e => handleClickEmoji(prevEmoji)}>{prevEmoji}
              </div>
            {/each}
            </div>
          {/if}

          <!-- Upgrade for  more Emoji link -->
          {#if !(user && user.plan)}  
            <div class="alert mt-4 text-sm flex flex-column items-start">
              <div>
                <a href="#" class="text-primary !text-[var(--aqua)] font-semibold hover:underline !cursor-pointer" on:click|preventDefault={() => {
                  displayUpgradeDialog('extra_emoji_upgrade_link');
                }}>Upgrade</a> 
                for more sticker and emoji suggestions.</div>
                <div class="flex flex-row">
                  {#each premiumGifs as premiumGif}
                    <a href="#" class="text-primary !text-[var(--aqua)] font-semibold hover:underline !cursor-pointer" on:click|preventDefault={() => {displayUpgradeDialog('extra_emoji_upgrade_link');}}>
                    <img alt="Mood description" class="mood-text-gif mood-description-gif-img mr-4" src={premiumGif.GifURL} title="">
                  </a>
                  {/each}
                </div>

            </div>
          {/if}
        </div>
      </div>

      <!-- Preview Card -->
      <div id="select-mood-card" style="margin-left: 40px; flex-direction: column; align-items: center">
        

        <div class="selectedAttendeeName">{selectedAttendee.name}</div>
        {#if debugMode}
          <div class="debug">selectedGiphy.title:{selectedGiphy? selectedGiphy.title: ''}</div>
          <div class="debug">sgiphySearchTerm:{giphySearchTerm}</div>
          <div class="debug">gifSentiment:{gifSentiment}</div>
          <div class="debug">currentSentiment:{currentSentiment}</div>
        {/if}

        <div class="selectedEmojiBox">

          <div style="display:flex; flex-direction:row; flex-wrap:wrap; width:100px;margin-left: auto; margin-right: auto;">
              {#if selectedGiphy}
                <div on:click={handleClickSelectedGiphy}>
                  <img alt="Display Gif" class="giphy-img" src={(selectedGiphy.images) ? selectedGiphy.images.original.webp :selectedGiphy.GifURL} style={betaFeaturesEnabled ? getGifGlowStyle(currentSentiment,selectedGiphy.is_sticker) : '' }/>
                </div>
              {/if}

              {#if combinedEmojiStickers.length == 0 && selectedGiphy == ''}
                <div class="emptyStateEmoji"><img src="/images/defaultMoodIcon.png" height="65px" width="65px" alt="default mood icon"/></div>
              {:else if combinedEmojiStickers.length >= 1}
                {#each combinedEmojiStickers as selected}        
                  {#if selected.GifURL }
                    <div
                    on:click={ () => handleClickSelectedSticker(selected.GifURL)} title="Click to remove" transition:scale="{{ duration: 200, easing: cubicOut }}"
                    class="selectedEmoji"
                    style="{getEmojiStyle(combinedEmojiStickers.length)}">
                       <img alt="Display Gif" class="giphy-img" src={selected.GifURL} 
                        style="{getStickerStyle(combinedEmojiStickers.length)}"/>
                     </div>
                  {:else}
                    <div
                      on:click={handleClickSelectedEmoji} title="Click to remove" transition:scale="{{ duration: 200, easing: cubicOut }}"
                      class="selectedEmoji"
                      style="{getEmojiStyle(combinedEmojiStickers.length)}">
                        {selected}
                    </div>
                    {/if}
                {/each}
              {/if}
          </div>

        </div>
         {#if (selectedEmoji.length >= 1 && betaFeaturesEnabled)}
                  <div class="mood-shape" style={'background-color:' + getSentimentColourCode(currentSentiment)}>
                    <!-- style="background-color: {getSentimentColourCode (currentSentiment)};transform:rotate(30)" -->
                  </div>
          {/if}

          <!-- What's the reason? -->
          <!-- {#if selectedEmoji.length > 0 || selectedGiphy != ''} -->
           {#if selectedEmoji.length > 0 || selectedStickers.length > 0 || !!selectedGiphy}

            
            <div transition:scale="{{delay:600, duration: 400, easing: cubicOut }}" style="text-align: center;">
             <!-- <div style="text-align: center; position: relative;top: 7px;right: 32px;">
              <img alt="Speech bubble" src="/images/SpeechBubbleTriangleGrey50.png"  
              style="Xposition: relative; top: 0px; left: 65px;"/>
            </div> -->
              <textarea id="whysThat" maxlength="140" bind:value={moodReason} cols="14" placeholder="Why's that?"style="Xmargin-top: 6px; border-radius: 8px" autofocus/>
            </div>

          {/if}

         {#if selectedEmoji.length == 0 && selectedGiphy == ''}
            <div class="select-some-emoji">Choose some emoji</div>
          {/if}

          <!-- Need Help?  BETA  -->
          {#if 1 > 2}
            {#if selectedEmoji.length > 0}
              {#if !showHelpField && helpRequired == ''}
                <div style="text-align: center;" in:scale="{{delay:1400, duration: 400, easing: cubicOut }}" out:scale="{{duration: 400, easing: cubicOut }}">
                  <a href="#" on:click={handleClickNeedHelp} id="INeedHelpButton" style="font-size: 18px"><span style="font-size: 22px;">☂️</span>&nbsp;<u>Need any Help</u>?</a>
                </div>
            
            {:else}
              <div transition:scale="{{duration: 400, easing: cubicOut }}" style="text-align: center">
                <div style="
                    font-size: 24px;
                  text-align: left;
                  margin-bottom: -14px;
                  margin-left: 10px;
                  background-color: white;
                  position: relative;
                  width: 20px;
                  background-color: #ffffff00;
                  "

    >☂️</div>
                <textarea id="helpRequiredField" maxlength="140" cols="14" placeholder="What do you need?" style="border-radius: 8px" bind:value={helpRequired} />
              </div>
            {/if}

            {/if}
          {/if}

        </div>

      </div>

      <div style="display:flex; margin-top:20px">
        <Button id="emoji-trigger" on:click={() => showEmojiPicker()}>More Emoji&nbsp; <span style="font-size: 20px">😀 😻 🙈</span></Button>
       
       <!-- {#if localStorage.getItem('MoodFirstBeta') == 'true'} -->
        &nbsp;  &nbsp;
          
      <!-- <div class="new-feature"> -->
          <Button id="giphy-button" on:click={() => showGiphyDialog = true} style="Xbackground-color: black !important; width: 124px">GIFs<img alt="Display Gif" src="/images/giphy.svg" style="height: 46px; width: auto" /></Button>
       <!-- </div> -->
        <!-- {/if} -->

        <Button style="margin-left: auto" on:click={handleCancelSelectMood} class="secondary">Cancel</Button>&nbsp;
        <Button id="UpdateMoodButton" class="primary" style="marigin-left: 8px !important" on:click={handleConfirmMood} text>OK</Button>
      </div>
    </div>
    </Dialog>

    <!-- Select Giphy Dialog -->
    <Dialog width="42vw" bind:active={showGiphyDialog} class="select-giphy-dialog">
       <Card style="background-color: white;padding: 20px; height: 540px">
        <form on:submit|preventDefault={handleSearchGiphy}>
          <input autofocus type="text" bind:value={giphySearchTerm} placeholder="Search for a GIF" id="giphy-search-input"/>
          <Button class="primary" on:click={handleSearchGiphy}>Go</Button>
        </form>
       <!--  <div>giphySearchPage: {giphySearchPage}</div>
        <div>giphySearchOffset: {giphySearchOffset}</div>
        <div>giphySearchResultsHeight: {giphySearchResultsHeight}</div>
        <div>size: {giphySearchresults.length}</div> -->
        <div id="giphy-search-scroll" on:scroll={checkGiphyScrollEnd}>
          <div id="giphy-search-results" style="height:{giphySearchResultsHeight}">
            {#each giphySearchresults as giphy}
              <div>
                <!-- <img class="giphy-search-result-img" src={giphy.images.original.url}  on:click={ e => handleSelectGiphy(giphy)}/> -->
                <img alt="Search Gif" class="giphy-search-result-img" src={giphy.images.original
.webp}  on:click={ e => handleSelectGiphy(giphy)}/>
              </div>

            {/each}
            
          </div>
           
        </div>
        <CardActions style="justify-content: flex-end">
            {#if giphyLoading}
              <div id="giphy-loading">
                <Icon spin data={faSpinner} scale="1.6"  style="color: var(--aqua) !important;"/>
              </div>
            {/if}
           <Button on:click="{e => showGiphyDialog = false}" text class="secondary">Cancel</Button>&nbsp;
        </CardActions>
       </Card>
    </Dialog>


    <!-- Share Board Dialgo -->
    <Dialog width="60vw" bind:active={showShareDialog}>
      <Card style="background-color: white;padding: 20px;">
        <div class="shareHeading">Scan QR Code to Join by Phone</div>
        <QRCode elementID="dialgQRCode" codeValue="{document.location.href.replace('&trialBoard=yes','')}" squareSize="180"/>
        <br/>
        <div class="shareHeading">Copy and Share link</div>
        <input id="boardURL" type="text" size="80" value="{document.location.href.replace('&trialBoard=yes','')}" /><button id="ShareBoardCopyURL" class="primary" on:click={copyBoardLink}>Copy</button>
        <CardActions style="justify-content: flex-end">
           <Button on:click="{e => showShareDialog = false}" text class="secondary">Close</Button>&nbsp;
        </CardActions>
      </Card>
      
    </Dialog>


  <!-- Snackbar: Confirm copied to clipboard -->
  <Snackbar class="justify-space-between" bind:active={showSnackbar} center timeout={2000}>
        Copied to clipboard
        <!-- <Button
          text
          on:click={() => {
            snackbar = false;
          }}>
          Dismiss
        </Button> -->
  </Snackbar>


    <!-- Analytics Dialog -->
    <Dialog width="56vw" bind:active={showAnalyticsDialog}>
      <Card style="background-color: white; padding-left: 20px; padding-right: 20px; padding-top:15px; padding-bottom: 15px; height: 60vh">
        <div id="chart-wrapper" style="width: {windowsOS ? '46vw' :'50vw'}; height: 46vh; margin-left: auto; margin-right: auto;">
          <MoodSentimentCart boardInstances={boardInstances} canvasName="sentimentChartZoom" zoom="true" moods={moods} chartTitle={thisBoard.title}/>
        </div>
         <CardActions style="justify-content: flex-end; margin-top: 16px">
            <!-- <div class="new-feature" style="margin-right: auto"> -->
             <Button id="copy-chart-to-clipboard" on:click={handleCopyChartToClipboard} style="margin-right: auto !important;">Copy to Clipboard&nbsp; <Icon data={faCamera} scale="1.6" style="Xfloat: right; color: var(--aqua) !important;" /> </Button>
            <!-- </div> -->
           <Button on:click="{e => showAnalyticsDialog = false}" text class="secondary">Close</Button>&nbsp;
        </CardActions>
      </Card>

    </Dialog>

    <!-- Idea Dialog -->
    <Dialog bind:active={showIdeaDialog} style="z-index:9999" width="600px">
      <Card style="background-color: white; padding: 16px 30px">
        <div class="idea-dialog-header">
          <Icon data={faLightbulb} scale="1.4" style="color: var(--green) !important;"  />
          New Idea
        </div>
        <div class="idea-dialog-themes">
          <b>Theme:</b>
          <input  bind:value={editIdeaTheme} class="idea-text-input" placeholder="Themes e.g. #busy"/>
        </div>
        <div class="idea-dialog-layout">
          <div class="idea-dialog-emoji">
            ☕️
          </div>
          <div class="idea-dialog-text">
            <textarea class="idea-text-area" bind:value={editIdeaText} placeholder="What's your idea? 😃"></textarea>
          </div>
        </div>
       
        <CardActions style="justify-content: flex-end; margin-top: 0px">
          <Button on:click={(e) => {showIdeaDialog = false;} } text class="secondary">Cancel</Button>&nbsp;
          <Button class="primary" on:click={handleConfirmUpdateIdea} text>Add idea</Button>     
         </CardActions>

      </Card>
    </Dialog>

     <!-- Get Assitance Dialog -->
    <Dialog width="900px" height="680" bind:active={showAssistanceDialog}>
      <Card style="background-color: white; padding-left: 20px; padding-right: 20px; padding-top:15px; padding-bottom: 15px;  ">
        <div class="recommendation-heading">{thisBoard ? thisBoard.title: ''}: Insights & Suggestions</div>
        
        <div class="summary-layout" style="display:flex; flex-direction: row; margin-top: 18px; margin-bottom: 32px; height: 80px">
          <div class="first-column" style="width: 50%;display:flex; flex-direction: row">
            <div>
               <Speedometer width={120} height={60} minValue={-0.52} maxValue={0.8}
            value={(currentInstance && currentInstance.avg_sentiment_score) ? currentInstance.avg_sentiment_score : 0.14} 
            needleColor="#255991" labelFontSize={0} ringWidth={12} needleTransition="easeElastic" needleTransitionDuration={6666}
            segments={11}
            segmentColors={['#DA1A0F', '#E85E37', '#EA683C','#F29053','#ECAB60','#439D37','#87B824','#AACD6F','#E8E88F','#FCF275','#FFF60D']} needleHeightRatio={0.55}/>

            </div>
            <div class="recommendation-summary">
              <!-- {summarySentenceStarter} -->
              Overall the the team is
              <div id="two-word-summary">{@html marked(summaryContent)}</div>
          </div> 
          </div>
           <div class="second-column" style="width: 50%;display:flex; flex-direction: row">
            <div>
              <div style="margin: 8px; width: 12vw; cursor: zoom-in"  on:click="{e => showAnalyticsDialog = true}">
                  <MoodSentimentCart boardInstances={boardInstances} moods={moods} canvasName="AssistanceDialogChart" />
              </div>
            </div>
            <div class="recommendation-summary">{@html marked(summaryTrendContent)}</div>
          </div>
        </div>
         <div id="suggestions-title">Here’s a few <b>fun suggestions</b> to help make the team even better❣️</div>
        <div class="recommendation-text" style="">
          {#if assistanceContent =='' }
            <div id="giphy-loading">
              <Icon spin data={faSpinner} scale="1.6"  style="color: var(--aqua) !important;"/>
            </div>
          {/if}
          <!-- {@html marked(assistanceContent,{sanitize: false})} -->
          {@html formattedAssistanceContent}
       </div>

       <CardActions style="justify-content: flex-end; margin-top: 16px">
         <Button on:click="{e => showAssistanceDialog = false}" text class="secondary">Close</Button>&nbsp;
      </CardActions>
      </Card>

    </Dialog>


    <!-- sign Up / Login Dialog -->
    <Dialog id="sign-up-dialog"bind:active style="z-index:9999" width="800px">
      <Card style="background-color: white; padding: 16px 30px">
        <MaterialApp>
          
          <div class="flex flex-row align-center" >
            <img src="/images/Logo_webclip_256.png" alt="MoodFirst Logo" class="svelte-1e8bb8t" style="align-self: center; width: 40px; height: auto; vertical-align: top">
            <h3 class="font-bold text-2xl text-[var(--blue)] ml-2">Save Your Mood Board</h3>
          </div>
          <div class="text-[var(--dark-grey)] my-2">
            Sign up for a free account to save the board for your team.
          </div>

         <div class="font-bold mb-0" style="color: var(--blue)">Email</div>
            <div class="mb-4">
              <input 
                type="email"
                placeholder="Enter your email address"
                bind:value={email}
                on:input={() => signUpErrorMessage = ''}
                class="input input-bordered w-full"
              />
            </div>

            <div class="flex justify-between items-center mb-0">
              <span class="font-bold" style="color: var(--blue)">Password</span>
              <span 
                class="cursor-pointer flex items-center gap-1"
                style="color: var(--aqua)"
                on:click={() => showPassword = !showPassword}
              >
                {showPassword ? 'Hide' : 'Show'}
                <Icon 
                  data={showPassword ? faEyeSlash : faEye} 
                  scale="1.6" 
                  style="color: var(--aqua)" 
                />
              </span>
            </div>

            <div class="mb-4">
              {#if showPassword}
                <input 
                  type="text"
                  placeholder="Enter a password"
                  bind:value={password}
                  on:input={() => signUpErrorMessage = ''}
                  class="input input-bordered w-full"
                />
              {:else}
                <input 
                  type="password"
                  placeholder="Enter a password"
                  bind:value={password}
                  on:input={() => signUpErrorMessage = ''}
                  class="input input-bordered w-full"
                />
              {/if}
            </div>

            {#if signUpErrorMessage !== ''}
              <div class="text-red-500 transition-opacity duration-500 ease-in">{signUpErrorMessage}</div>
            {:else}
              <div class="h-6">&nbsp;</div>
            {/if}






          <CardActions style="justify-content: flex-end; margin-top: 0px">
             <Button on:click={closeDialog} text class="secondary">Cancel</Button>&nbsp;
             {#if signUpAlreadyRegistered}
              <Button class="primary" on:click={handleLogin} text>Login</Button>
             {:else}
              <Button id="SaveBoardSignUP" class="primary" on:click={handleSignUp} text>Create My Account</Button>
             {/if}
           </CardActions>

           <div style="padding: 0px 8px; margin-top: -6px">
              <span style="text-align: left">If you already have an account <a style="cursor:pointer" Xon:click={() => alreadyRegisered()} href="/login">click here</a>.
             </span>  
             <span style="text-align: right; float:right">I agree to <a target="_new" href="/TOC">MoodFirst's Terms of Service</a>
             </span> 
           </div>

         </MaterialApp>
      </Card>
    </Dialog>

    <!-- Confirm Delete Attendee Dialog -->
    <Dialog persistent bind:active={confirmmDeleteActive}>
      <Card style="background-color: white;">
        {#if $user}
        <CardTitle class="dialogTitle">Say goodbye to {deleteAttendeeName}? <span style="font-size: 26px">&nbsp;🥹</span></CardTitle>
        <CardText>
          Are you sure you want to delete this attendee and all of their previous moods?
        </CardText>
        <CardActions>
        <div style="margin-left: auto">
        <Button on:click={closeConfirmAttendeeDelete} text class="secondary">Cancel</Button>&nbsp;
         <Button on:click={handleDeleteAttendee} class="buttonDanger" style="float:right">Yes - Remove</Button>
         </div>
        </CardActions>
        {:else}
          <CardTitle class="dialogTitle">Remove Attendee</CardTitle>
          <CardText>
            Sorry, you must be logged in as the board owner to remove an attendee. 🥹
          </CardText>
          <CardActions>
          <div style="margin-left: auto">
          <Button on:click={closeConfirmAttendeeDelete} text class="secondary">Cancel</Button>&nbsp;
           </div>
          </CardActions>
        {/if}
      </Card>
    </Dialog>

     <!-- Advise user they need to be logged in as the board owner to modify the board-->
    <Dialog bind:active={displayBoardChangesOwnerMessage}>
      <Card style="background-color: white;">
       
        <CardTitle class="dialogTitle">Sorry... 🥹</CardTitle>
        <CardText>
          You must be logged in as the board owner to {boardChangeOperation}.
        </CardText>
        <CardActions>
        <div style="margin-left: auto">
        <Button on:click={e => {displayBoardChangesOwnerMessage=false}} text class="secondary">Close</Button>&nbsp;
         </div>
        </CardActions>
   
      </Card>
    </Dialog>


    <!-- Confirm Delete Date Dialog -->
    <Dialog persistent bind:active={confirmDeleteDateActive}>
     
      <Card style="background-color: white">
        {#if $user}
          <CardTitle class="dialogTitle">Remove this Date?</CardTitle>
          <CardText>
            Are you sure you want to delete this date along with all the moods?
          </CardText>
          <CardActions>
            <div style="margin-left:auto">
            <Button on:click={closeConfirmDeleteDate} text class="secondary">Cancel</Button>&nbsp;
             <Button on:click={handleDeleteDate} class="buttonDanger" style="float:right"> Yes - Remove</Button>
            </div>
          </CardActions>
        {:else}
            <CardTitle class="dialogTitle">Remove Date</CardTitle>
          <CardText>
            Sorry, you must be logged in as the board owner to remove a date. 🥹
          </CardText>
          <CardActions>
            <div style="margin-left:auto">
            <Button on:click={closeConfirmDeleteDate} text class="secondary">Cancel</Button>&nbsp;
            </div>
          </CardActions>
        {/if}
      </Card>
    </Dialog>

  <UpgradeDialog
    visible={showUpgradeDialog}
    onClose={() => showUpgradeDialog = false}
    premiumGifs = {premiumGifs}
  />

  <!-- Daisy UI Drawer wrapper (right side) -->
  <div id="board-settings-drawer" class="drawer drawer-end" style="z-index:9999 !important;">
  <!-- Toggle input controlled by Svelte -->
  <input id="drawer-toggle" type="checkbox" class="drawer-toggle" bind:checked={drawerOpen} />
 
  
  <!-- The drawer itself -->
  <div class="drawer-side" style="height:105%">
    <!-- Overlay (clicking closes drawer) -->
    <!-- <label for="drawer-toggle" class="drawer-overlay bg-black/40"></label> -->ç
  <label
  for="drawer-toggle"
  class="drawer-overlay"
  style="background-color: rgba(0, 0, 0, 0.4) !important; "
></label>

    <div class="menu pr-8 p-4 w-80 min-h-full bg-base-200 text-base-content">

     <h2 class="flex items-center gap-2 text-lg font-bold mb-4 text-[var(--blue)]">
        <Settings2 class="w-6 h-6 text-[var(--aqua)]" />  Board Settings
      </h2>

      <details class="collapse collapse-arrow bg-base-100 border-base-300 border">
        <summary class="collapse-title font-semibold text-[var(--blue)]">⏰ Microsoft Teams Reminder</summary>
        <div class="collapse-content text-sm">
          
          {#if user && user.plan}
          <Reminder
            {reminder}
            mode={showReminderForm ? 'edit' : 'view'}
            on:edit={() => showReminderForm = true}
            on:cancel={() => showReminderForm = false}
            on:save={handleSaveReminder}
          />
          {:else} 
            Please
            <a 
              href="#"
              class="text-[var(--aqua)] font-semibold hover:underline"
              on:click|preventDefault={() => {
                displayUpgradeDialog('reminders_upgrade_link');
                drawerOpen = false;
              }}>
              Upgrade
            </a>
             for this feature.

          {/if}

        </div>
      </details>

    </div>
  </div>
  
</div>

  <style>

  :global(body) {
    margin: 0;
    padding: 0;
  }

  :global(.buttonDanger){
    background-color: red !important;
    color: white !important;
  }

  :global(.s-btn .s-btn__content) {
      text-transform: none !important;
      font-size: 18px !important;
  }

  :global(.secondary){
    background-color: grey !important;
  }

  :global(.dialogTitle) {color: var(--blue)!important; font-weight: bold !important; text-align: left}

  :global(.Xemoji-picker__wrapper) {z-index: 9999 !important}
  :global(.picker) {
      --secondary-background-color: white !important;
/*      --search-background-color: pink !important;*/
/*    --category-name-background-color: green !important;*/
  } 
  :global(.popUpPicker) {
    z-index: 99999 !important;
    box-shadow: 0 11px 15px -7px rgb(0 0 0 / 20%), 0 24px 38px 3px rgb(0 0 0 / 14%), 0 9px 46px 8px rgb(0 0 0 / 12%);
  } 
  :global(.picmo__emojiButton) {border: 0 !important}

  :global(input:focus) { outline: 1px solid var(--aqua);}

  :global(.s-card-text) {font-size: 16px !important}


/* Header Styles */
.boardHeader {margin:0; Xpadding-left: 6%; Xpadding-right: 6%; height: 100px; Xline-height: 100px}
.boardTitle {Xcolor: white; Xfont-family: poppins; font-size: 30px; color: var(--blue); font-weight: bold; margin-bottom: 6px}
.boardTitle-boardMode {font-size: 18px; color: var(--blue); font-family: poppins; margin-left: 20px}
.boardQuestion{color:var(--blue); font-weight: bold;  font-size:2.8rem; line-height: 3.2rem; font-family: poppins;}
header{padding-left: 6%; min-height:48px ; height: 6vh; Xheight:50px; line-height: 50px; display: flex; flex-direction: row;}

/* Grid Styles */
:global(.icon-action) {background-color: white; 
/*  box-shadow: 0 6px 8px 0 #0003; */
    box-shadow: 0 1px 2px 0 #0003;
  border-radius: 50%; height: 32px; width: 32px;display: flex; justify-content: center; align-items: center;cursor: pointer;
/*   border: var(--aqua) 0.5px solid;*/
}
:global(.icon-action-small) {background-color: white; box-shadow: 0 6px 8px 0 #0003; border-radius: 50%; height: 24px; width: 24px;display: flex; justify-content: center; align-items: center;cursor: pointer}


/* Board Header Styles */
#sentimentChart{height:143px!important; width: 284px !important;   box-shadow: 0 0 1px rgba(255,255,255,.5); background-color: #fafafa; padding:4px}

/* Mood Board Styles */
#scroll-mood-grid {overflow-x: scroll; overflow-y: visible !important; padding-bottom: 42px; flex-grow: 7; min-width:0;
  margin-left:6%; margin-right: 6%;
  Xmargin-right: 22px; 
}

#board-container {margin-left:6%; 
  margin-right: 6% /* remove for right panel */
}
#mood-board{overflow-x: auto; display: table; transition: all 600ms ease;
Xmax-width:0 } /* max-width is set to prevent the element increasing the size of the parent (scroll-mood-grid) element */

label {background-color: green !important}
body > div.board-controls-row.svelte-1wtidih > div:nth-child(1) > div > label {background-color: purple !important}
.date-wrapper {display: flex; flex-direction: row; justify-content: center; width: 298px }
.board-disp-current-day{color: var(--aqua); font-weight: bold; font-size: 22px;Xwidth: 124px; text-align: center;}
.board-date-spacer {color: var(--aqua);text-align: center; font-size: 22px}
.board-disp-current-date {color: var(--aqua); font-weight: bold; font-size: 22px; margin-right: 4px; Xwidth: 152px; text-align: center;}
.board-date-nav {cursor: pointer !important; color: var(--aqua); display: flex; margin-bottom: 3px}
.board-date-nav-disabled{color: #d2d2d2; display: flex}
.board-date-nav:hover {color: var(--blue)}
.boardLayout {display: flex; flex-wrap: wrap;  transition: inherit;
/*  max-width: 68vw; -- Reneable for right panel*/ 
}
.boardTableHeaderRow {display: table-row; transition:inherit}
.boardTableRow {display:table-row;Xheight: 96px; min-height: 96px; transition:inherit;max-width: 68vw;}

/* Column Headings */
.date-cell {text-align: center; font-weight: bold; position: relative; Xtransition: opacity 0s !important;}
.date-cell:hover .delete-date {opacity: 1}
.currentDate{color:var(--aqua)}
.delete-date{color:#b0b0b0; opacity: 0; position: absolute; left:0; top: 0;
padding-top:4px; padding-left: 4px; transition: opacity 0.5s ease-in-out;}
.delete-date:hover{color: var(--aqua) !important;}

 /* Mood cell/card  Styles */  
.boardTableCell {display: table-cell; border:#dbdbdb solid 0.6px; Xmax-width: 10%; Xmin-width: 90px;min-width: 124px; transition:inherit;  background-color: white; }
.colHeader{font-weight:bold;text-align: center; color:var(--blue);transition:inherit; position: relative;}
.colHeader:hover .delete-attendee {opacity: 1}
.board-attendee-name {color: var(--blue); Xtransition: all 2s ease; font-size: 18px; font-weight: bold; z-index: 2}
.delete-attendee {position: absolute; top:0; left:0; padding-top:6px; padding-left: 6px; opacity:0;transition: opacity 0.5s ease-in-out; color: #b0b0b0}
.delete-attendee:hover {color: var(--aqua);}

.mood { text-align: center;font-size: 42px; cursor: pointer; vertical-align: middle; padding: 6px;}

.zoomableInsights:hover {
  transform: scale(1.2);
  z-index: 888;
  transition: all 200ms ease;
  position: relative;
  border-radius: 6px;
  border: var(--aqua) solid 2px;
  background-color:white ;    box-shadow: 0 6px 8px 0 #0003;
}

.insightsMessage {
  opacity: 0;
  display: none;
  transition: opacity .2s;
  overflow: hidden;
/*  border-right: .15em solid orange;*/
  white-space: nowrap;
  margin: 0 auto;
  Xletter-spacing: .15em;
  clip-path: inset(0 100% 0 0); /* hide the text initially */
  color: var(--blue);
  margin-top: -20px;
  margin-bottom: 20px;
  text-align: center;
}

.zoomableInsights:hover .insightsMessage {
  opacity: 1;
  display: block; 
  animation: typing .9s steps(40, end) forwards;
}

/* The typing effect */
@keyframes typing {
  from { clip-path: inset(0 100% 0 0); }
  to { clip-path: inset(0 0% 0 0); } /* reveal the text */
}


.zoomable:hover{transform: scale(1.65); z-index: 99; transition: all 200ms ease; position: relative; border-radius: 6px;}
.zoomable.windowsOS:hover{transform: scale(1.45); z-index: 99999; transition: all 200ms ease; position: relative;border-radius: 6px;}

.zoomable:hover .reasonContainer{display:none}
.zoomable:hover .reasonContainerZoom{display:inline;}

.mood-card {min-width: 168px; max-width: 168px;  min-height: 180px; margin-left:0; margin-right: 14px; margin-bottom: 12px; 
/*  box-shadow: 0 6px 8px 0 #0003; */
  box-shadow: 0 4px 6px 0 #0003; 
  border-radius: 8px;transition:inherit; 
  }

.emojiBox {display: flex; flex-flow: row wrap; width: 100px; margin-left: auto; margin-right: auto; justify-content: center; height: 90px; align-items: center; z-index: 2}
/*.emojiBox .emoji:nth-child(1) {
  transform: rotate(-8deg);
}*/

.display-mood-text{margin-left: auto; margin-right: auto; z-index: 3; font-size: 22px; font-weight: bold;}

.mood-shape {
  height: 102px; width: 102px;
  border-radius: 50%;
  z-index: 1; position: relative;
  margin-top: -98px;
  margin-left: auto; margin-right: auto;
}
.mood-shape::before {
    content: '';
    position: absolute;
    top: -20px; 
    left: -20px;
    right: -20px;
    bottom: -20px;
    background: inherit;
    z-index: -1;
    filter: blur(8px);
     border-radius: 50%;
}


.emoji {margin-right: 2px;}
.giphy-container {margin-top: 6px;}
.giphy-img { max-width: 120px; height: auto; border-radius: 6px;  Xfilter: brightness(0.8) Xsaturate(0.2) Xhue-rotate(-30deg);}

@keyframes subtleMove {
  0%, 100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(2px, 2px);
  }
}

 .mood-text {
    font-size: 19px; font-family:  'Fresca', sans-serif;  font-weight: bold; color:var(--blue);
    border-radius: 10px; background-color: #e3e3e380;
    padding-left: 1.5px; padding-right: 1.5px; padding-top: 4px; padding-bottom: 4px;
    min-height: 44px; max-height: 180px;
    overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-box-orient: vertical; 
 }
.reasonContainer { position: relative;}
.reasonContainerZoom {display:none; }

.moodReason { 
    height: 62px;
    width: 100%; text-align: center; 
    margin-left: auto;
    margin-right: auto;
    transition: all 0.3s ease-in-out;
    -webkit-line-clamp: 4;
    line-height: 18px;
  } 
  .moodReasonZoom { 
    height: 60px;
    width: 100%; text-align: center; 
    margin-left: auto;
    margin-right: auto;
    transition: all 0.3s ease-in-out;
    -webkit-line-clamp: 6;
    line-height: 12px !important;
     font-size:11px !important;
     z-index:99999;
  } 

  .collapse-hide {width: 0 !important; min-width: 0 !important; overflow: hidden; border: none !important; opacity:0;}
  .collapse-vertical-hide {height: 0px !important; min-height: 0px !important; line-height:0 !important;overflow: hidden !important; border: none !important}


/* Get Assitance Dialog Styles */
.recommendation-heading {font-weight: bold; color: var(--aqua); font-size: 22px; margin-bottom: 6px}
.recommendation-text {white-space: pre-wrap; overflow:scroll; max-height: 32vh; min-height: 32vh; color: var(--blue); background-color: #fafafa}
:global(.recommendation-text p) {margin-bottom: 0px !important;}
:global(.emoji-cat) {
  font-size: 24px; margin-right:4px;
}
.recommendation-summary {color: var(--blue); font-size: 18px; line-height: 22px}

.rightBar {   border: 1px solid #dbdbdb; padding: 8px; transition: flex-basis 0.5s;}
.expandedRightBar{ Xwidth: 320px ; flex-basis: 25%; padding: 8px}
.collapsedRightBar{ flex-basis: 4%}

.suggestions-title {color: var(--green); font-size: 22px; font-weight: bold; margin-left: auto; margin-bottom: 8px}
.suggestions-desc {color: var(--blue)}
.suggestions-sub-title{color: var(--blue); font-weight: bold; margin-top: 12px}
.suggestions-container{ overflow-y:scroll; padding: 4px}
.suggestion-entry {margin-bottom: 8px; margin-top: 8px; background-color: #fafafa; }
.suggestion-emoji{border-radius: 50%; background-color: #8ae3c780; font-size: 22px; padding:6px}
.suggestion-text {color: var(--blue); font-size: 18px}

.ideas-top-bar{display: flex; flex-direction: row; align-items: center;}
.idea-add {margin-left: auto; margin-right: 6px}
.idea-entry{background-color: rgba(159, 225, 200, 0.24); padding:8px; border-radius: 6px; margin-bottom: 8px; margin-right: 16px; transition: transform 4.1s;
}
.idea-themes-container {display:flex; flex-direction: row}
.idea-theme { padding: 4px; border-radius: 4px; color: var(--blue)}
.idea-emoji-text-container{display: flex; flex-direction: row}
.idea-emoji{text-align: center;font-size: 60px;line-height: 35px; padding: 2px 6px;     padding-top: 8px;}
.idea-text {color: var(--blue); font-weight: bold; font-size: 18px;line-height: 20px;}
.idea-votes-status-container {display:flex; flex-direction: row; margin-top: 6px;}
.idea-vote{font-size: 18px}
.idea-vote.action{cursor: pointer !important;}
.idea-status {margin-left: auto}
.themes-title {color: #8c8c8c; font-size: 18px; font-weight: bold}
.theme-entry{display: flex; flex-direction: row;background-color: #F4F4F4; xbackground-color: rgba(159, 225, 200, 0.24); border-radius: 6px; border: dashed 1px #D1D2D2; margin-bottom: 8px; margin-right: 16px; padding: 4px 8px; align-items: center;}
.theme-emoji{font-size:24px}
.theme-label {color: var(--blue);Xmargin-left: auto;margin-right: auto; font-size: 18px; font-weight: bold}
.theme-add {Xmargin-left: auto; cursor: pointer; }
.theme-generate {margin-left:6px;cursor: pointer;}
.icon-action-mini {
    background-color: white;
    box-shadow: 0 2px 4px 0 #0003;
    border-radius: 50%;
    height: 28px;
    width: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}
.idea-dialog-header {color: var(--green);font-size: 22px; font-weight: bold }
.idea-dialog-layout{display:flex; flex-direction: row; align-items: center;}
.idea-dialog-emoji{font-size: 60px;line-height: 35px;width: 84px;   }
.idea-dialog-text{display: flex;}
.idea-text-area {width: 416px;height: 68px; margin-bottom: 0px !important;}
.idea-text-input{width: 500px}
.idea-dialog-themes{color: var(--green);margin-bottom: 12px;}

:global(#two-word-summary) {
  font-size: 1.6em;
  font-weight: bold;
  line-height: 32px;
  color: var(--blue);
}

#suggestions-title {color: var(--blue); font-size: 18px; margin-top: 12px; margin-bottom: 12px;}


/* Share Board Dialog */
.shareHeading{font-weight: bold; color: var(--aqua); font-size: 22px; margin-bottom: 6px}

/* Select Mode: Grid or Board */
:global(.s-list) {background-color: white !important}


/* Empty State and Validation Messages */
.board-controls-row{display: flex; flex-direction: row; align-items: center; margin-left: 6%; margin-right: 6%; }
.emptyStateMessage{color: var(--aqua); font-size:22px;margin-left: 80px; Xmargin-left:140px;position: relative; height: 50px; display: flex}
.addAttendeeError{color: red; vertical-align: top; font-size: 20px}
  
:global(.form-error) {background-color: white !important; font-size: 20px !important; border: 1px solid var(--aqua) !important}

 /* Select Mood Styles */

.selectMoodTitle{font-size: 32px; line-height: 34px; color: var(--blue)}
#categoryNavigationBar {font-size: 14px; color: #6e6e6e; cursor: pointer; display: flex; flex-wrap: wrap}
.select-some-emoji {font-size:16px; color:grey; text-decoration: italic; text-align: center;}
.emojiCategoryTitle {color: var(--aqua); font-weight: bold; margin-top: 10px}
.selectedAttendeeName{font-size: 32px; line-height: 34px; text-align: -webkit-center; color: var(--blue); z-index: 4}
.emojiList { overflow-y: auto;  white-space: nowrap;height: 360px; }
::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
}
::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0,0,0,.5);
    box-shadow: 0 0 1px rgba(255,255,255,.5);
}
.emojiCateoryContainer {width: fit-content}
.chooseEmoji{text-align: center; font-size: 38px; width: fit-content; cursor: pointer; Xborder: 1px solid #96969680; margin-top: -1px; padding-left: 3px; padding-right: 3px; border-radius: 50%;    width: 48px;
    height: 48px;    display: flex;
    justify-content: center;
    align-items: center;
    transition: transform 0.2s ease-in-out;
}
.chooseEmoji:hover {transform: scale(1.35);}

#mood-description-gif-container {display:flex; margin-top:8px;flex-wrap: wrap;}
.mood-description-gif-img{height: 48px; width: auto; border-radius: 6px; margin-right: 8px; cursor: pointer;}
.mood-text-gif { transition: transform 0.2s ease-in-out;}
.mood-text-gif:hover {   transform: scale(1.45); z-index: 6  ; cursor: pointer;}

#select-mood-card {border: 1px solid #dbdbdb; border-radius: 6px; padding: 8px; box-shadow: 0 6px 8px 0 #0003;
  width: 248px; min-height: 300px; align-self: flex-start; display: flex; flex-direction: column;     
}
.emptyStateEmoji {text-align: center; margin-left: auto; margin-right: auto;}
.selectedEmoji {text-align: center; cursor: pointer; margin-left: auto; margin-right: auto;z-index: 2}
/* .singleEmoji{text-align: center;font-size: 66px; cursor: pointer;    margin-left: auto; margin-right: auto;} */
/* .multipleSelectedEmoji {text-align: center;font-size: 48px; cursor: pointer;    line-height: 55px} */
.selectedEmojiBox{ Xborder: #96969680 solid 1px; width: 155px; text-align: -webkit-center;min-height: 108px; Xheight: 140px;display: flex; flex-direction: column; align-items: center;margin-left: auto; margin-right: auto;z-index: 2}
#whysThat {width: 155px; height:70px; overflow: hidden; Xborder: var(--aqua) solid 1px !important; Xbackground-color: var(--green-50); background-color: #e3e3e380; border: 0 !important}
#whysThat::placeholder {color: light-grey; Xcolor: white; color: var(--aqua); font-weight: 400; width: 140px}
#whysThat:placeholder-shown {font-size: 18px}
#whysThat:focus {outline: 0 !important}
#helpRequiredField{Xborder: var(--aqua) solid 1px !important;width: 155px; background-color: #e8d4f4;border: none !important; }
#helpRequiredField::placeholder {color: var(--aqua); font-weight: 400; width: 140px}
#helpRequiredField:placeholder-shown {border: none !important; }
#helpRequiredField:focus {
  outline: none;
  border: none !important;
}

/* Select Giphy Styles */
.s-dialog__content.select-giphy-dialog {
    margin-left: -200px;
}
#giphy-search-input {width: 360px}
#giphy-search-scroll {height: 380px; overflow-y: scroll}
#giphy-search-results {display: flex; flex-direction: column; flex-wrap:wrap; max-width: 52vw;Xmin-height: 800px;
    Xoverflow: scroll;    overflow-y: scroll;
    overflow-x: hidden;}
.giphy-search-result-img {max-width: 180px; margin-right: 8px; cursor: pointer; border-radius: 4px;}
#giphy-loading {margin-right: auto; }
#INeedHelpButton {border-radius: 50%; height: 80px; width: 80px; Xtext-decoration: underline;color: var(--aqua); font-size: 18px; cursor: pointer}

.debug{ font-size: 14px; background-color: black; color: white; margin-bottom: 2px; width: 100%; }

/* Mood Chart Styles */
#copy-chart-to-clipboard{margin-right: auto}

/* Team Mood Check and Team Goal Tabs */
  .tab-bar {
    display: flex;
    flex-direction: row;
    margin-left: 6%; /* Adjust as needed */
    background-color: #fafafa; 
    border-bottom: 2px solid var(--aqua); 
    width:520px;
    margin-bottom:4px;
  }

   .tab {
    padding: 8px 16px;
    background-color: #fafafa; /* Slightly darker than tab-bar */
    color: #333; /* Darker text */
    cursor: pointer;
    border: none;
    font-size: 14px;
    font-weight: 500;
    line-height: 1;
    text-align: center;

    flex: 1; /* Add this to make tabs take equal width */
    border-radius: 4px 4px 0 0; /* Rounded top corners */
    margin-right: 8px; /* Spacing between tabs */
    transition: background-color 0.2s ease-in-out; /* Smooth transition */
  }

  .tab.active-tab {
    color: white;
    background-color: var(--aqua);
    border-bottom: 2px solid transparent; /* Hide bottom border on active tab */
  }

  .tab:hover {
    background-color: #d0ece7; /* Slightly darker on hover */
  }

  /* Fun Indicator (Example: Colored Dot) */
  .tab::after {
    content: "";
    display: block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: transparent; /* Initially hidden */
    position: absolute;
    top: 4px;      /* Adjust position as needed */
    right: 4px;    /* Adjust position as needed */
    transition: background-color 0.2s ease-in-out;
  }
  .tab.has-update::after {
    background-color: #ff4d4d; /* Red dot for update */
  }


  </style>